import React, { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import dayjs from "dayjs";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import priceCalculator from "@heartinz/gst_india_product_price_calculator";
import finance from "@heartinz/finance";
import {toPrimaryUnitPrice,toSecondaryUnitPrice,toPrimaryQuantity,toSecondaryQuantity,getAllPriceList} from "@heartinz/finance"

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";

import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import { useAuth } from "../../../context/AuthProvider";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { usePermission } from "../../../context/PermissionContext";
import uRLs from "../../../utils/baseUtils";
import AddImage from "../product/AddImage";
import { useLocation } from "react-router-dom";
import SearchInput from "../../../constants/SearchInput";
import CustomUnit from "../product/CustomUnit";
import EditProduct from "../product/EditProduct";
import { handleUnitNameSelect, handleUnitselect } from "../../../utils/unitUtils";
import ProductSearchList from "../../../constants/ProductSearchList";
import { handleChange } from "../../../utils/ProductHandleChange";
import { AddIcon, BarcodeIcon, EditIcon, ErrorCircleIcon, LineDoubleIcon, PlusIcon, StockAddIcon, XIcon } from "../../../constants/Icons";

const AddStock = ({
  isActive,
  ListRecentStock,
  handleSetRecentStock,
  searchOpen,
  noteSuggests,
  noteOpenStatus,
  setIsAnyInputFocused,
  brandSuggest,
  setBrandSuggest,
  editData,
  onClose,
  onEdit,
  navigatelist,
  isBtnLoad,
  isEditModalOpen,
  setEditModalOpen,
  setProductEditData,
  productStockData,
}) => {
  const location = useLocation();
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isButtonLoading, setButtonLoading] = useState(false);
  const [error, setErrors] = useState("");
  // const [isSelectedRadio, setSelectedRadio] = useState("SALEPRICE");
  const [toggles, setToggles] = useState({ stock: true });
  const [loading, setLoading] = useState({ stock: false });
  const { checkNetwork } = useNetwork();
  const { isUser,settings } = useAuth();
  const serverTime = GetServerLiveTime();
  const showAlert = useShowAlert();
  const { permission, hasPermission, viewOption, setGlobelPopupOpen } =
    usePermission();
  const hasFetched = useRef(false);
  const { data } = location?.state || {};
  const [noteSuggest, setNoteSuggest] = useState([]);
  const [showNotePopup, setShowNotePopup] = useState(false);
  const [filteredNoteSuggestions, setFilteredNoteSuggestions] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [imageFile, setImageFile] = useState(null);
  const [isImageModalOpen, seImageModalOpen] = useState(false);
  const [showProductSelect, setShowProductSelect] = useState(true);
  const [imagePreview, setImagePreview] = useState(
    "/assets/images/avatars/default.jpg",
  );
  const [unitSuggest, setUnitSuggest] = useState([]);
  const [AddUnitopen,setAddUnitopen]=useState(false);
  const [unitData,setUnitData]=useState();
  const [payloadData,setPayloadData]=useState();
  const [selectedUnit,setSelectedUnit]=useState()
  const productCodeRef = useRef(null);
  const searchTagRef =useRef(null);
  const productCodeGenerate = useRef(null);
  const productHsnsacRef = useRef(null);
  const productTitleRef = useRef(null);
  const productNoteRef = useRef(null);
  const suggestionNoteRef = useRef([]);
  const containerRef = useRef(null);
  const searchRef = useRef(null);
  const productShortNameRef = useRef(null);
  const productMrpRef = useRef(null);
  const productSalepriceRef = useRef(null);
  const productTaxpercentageRef = useRef(null);
  const productBasepriceRef = useRef(null);
  const productMdateRef = useRef(null);
  const productMultiCostRef = useRef(null);
  const productLandingCostRef = useRef(null);
  const suggestionRefs = useRef([]);
  const manufacturedateRefs = useRef(null);
  const expiredateRefs = useRef(null);
  const addStockBtnRef = useRef(null);
  const popupMrpInputRef = useRef(null);
  const [showMrpPopup, setShowMrpPopup] = useState(false);
  const [popupMrpValue, setPopupMrpValue] = useState("");
  const [popupMrpStyle, setPopupMrpStyle] = useState({});

  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const itemRefs =useRef([]);
  const [isBrandFocused, setIsBrandFocused] = useState(false);
  const [filteredBrand, setFilteredBrand] = useState([]);
  const [brandIndex,setBrandIndex]=useState(-1)
  const [showSuggestions, setShowSuggestions] = useState(false);
  const brandRef=useRef(null);
  const primaryRef = useRef(null);
  const [searchBrand, setSearchBrand] = useState("");
  const [brandData, setBrandData] = useState({
    title: "",
    _id: "",
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [isProductSugesstions, setProductSugesstions] = useState([]);
  const [selectedProduct, setselectedProduct] = useState(null);
  const [activeIndex, setActiveIndex] = useState(-1);
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const requestIdRef = useRef(0);
  const [isProductData, setProductData] = useState({
    code: "",
    hsnsac: "",
    title: "",
    note: "",
    mrp: 0,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    quantity: 0,
    landingcost: 0,
    lcmultiplayer: 0,
    finalLandingCost: 0,
    isLock: "SALEPRICE",
    shortName:"",
  });
  const [isApiData, setApiData] = useState({
    code: "",
    hsnsac: "",
    title: "",
    note: "",
    mrp: 0,
    quantity: 0,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    landingcost: 0,
    isLock: "SALEPRICE",
    primaryUnit:"",
    secondaryUnit:"",
    conversionValue:0,
  });
  const baseRef = useRef({
    mrp: 0,
    saleprice: 0,
    baseprice: 0,
  });
  const originalPrimaryRef = useRef({
    mrp: 0,
    saleprice: 0,
    baseprice: 0,
  });
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };
  // console.log(baseRef.current.mrp,baseRef.current.saleprice,baseRef.current.baseprice);
  const handleUnitConversion=(unitName,type)=>{

    if (unitName === selectedUnit) return;
    
    setSelectedUnit(unitName)
    if(uRLs.UNIT==="true"){
    let numericMrp = CurrencyConverter.toSubunit(baseRef.current.mrp || 0, "INR");
    let numericSaleprice = CurrencyConverter.toSubunit(baseRef.current.saleprice || 0, "INR");
    let numericBaseprice = CurrencyConverter.toSubunit(baseRef.current.baseprice || 0, "INR");
    let numericTaxpercentage = parseInt(isProductData?.taxpercentage);
    let quanity = isProductData?.quantity||0;
    let lock = isProductData?.isLock;
    if(type==="p"){
      // console.log("p",numericMrp,numericSaleprice,numericBaseprice,numericTaxpercentage,quanity,lock)
      const value=toPrimaryUnitPrice(numericMrp,numericSaleprice,numericBaseprice,
        numericTaxpercentage,quanity,lock,unitData)
        // console.log("p",value)
        const primaryQuantity=toPrimaryQuantity(quanity,unitData)
        setProductData((prev) => ({
          ...prev,
          mrp: CurrencyConverter.toCurrency(isApiData.mrp, "INR"),
          saleprice: CurrencyConverter.toCurrency(isApiData.saleprice, "INR"),
          baseprice: CurrencyConverter.toCurrency(isApiData.baseprice, "INR"),
          taxamount: CurrencyConverter.toCurrency(value?.primaryUnitPrice?.taxAmount, "INR"),
          discount: CurrencyConverter.toCurrency(value?.primaryUnitPrice?.discount, "INR"),
          // quantity: Number(value?.primaryUnitPrice?.quantity),
          quantity: 0,
        }));
        baseRef.current={
          mrp:isApiData.mrp/100,
          saleprice:isApiData.saleprice/100,
          baseprice:isApiData.baseprice/100,
        }
        // console.log("isApiData",isApiData)
      setApiData({
        ...isApiData,
        // quantity:Number(primaryQuantity?.primaryQty),
        quantity:0,
      })
    }
      
  else if(type==="s"){
    // console.log("s",numericMrp,numericSaleprice,numericBaseprice,numericTaxpercentage,quanity,lock)
    const value=toSecondaryUnitPrice(Number(numericMrp),Number(numericSaleprice),Number(numericBaseprice),
      numericTaxpercentage,quanity,lock,unitData)
      // console.log("s",value)
      const secondaryQuantity=toSecondaryQuantity(quanity,unitData);
      const primaryQuantity=toPrimaryQuantity(secondaryQuantity.secondaryQty,unitData)
      setProductData((prev) => ({
        ...prev,
        mrp: CurrencyConverter.toCurrency(value?.secondaryUnitPrice?.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(value?.secondaryUnitPrice?.salePrice, "INR"),
        baseprice: CurrencyConverter.toCurrency(value?.secondaryUnitPrice?.basePrice, "INR"),
        taxamount: CurrencyConverter.toCurrency(value?.secondaryUnitPrice?.taxAmount, "INR"),
        discount: CurrencyConverter.toCurrency(value?.secondaryUnitPrice?.discount, "INR"),
        quantity: 0,
        // quantity: Number(value?.secondaryUnitPrice?.quantity),
      }));
      // console.log("isApiData",isApiData)
      baseRef.current={
        mrp:value?.secondaryUnitPrice?.mrp/100,
        saleprice:value?.secondaryUnitPrice?.salePrice/100,
        baseprice:value?.secondaryUnitPrice?.basePrice/100,
      }
     setApiData({
      ...isApiData,
      quantity:0,
      // quantity:Number(secondaryQuantity?.secondaryQty),
    })
  }
    }
  }
  const iso = serverTime.toISOString();
  const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);

  const [manufacturedate, setMDate] = useState(null);
  const [expiredate, setEDate] = useState(null);
  const [expireMinDate, setExpireMinDate] = useState(iso);
  const [openMfgDate, setOpenMfgDate] = useState(false);
  const [openExpDate, setOpenExpDate] = useState(false);
  const defaultConversion = settings?.defaultUnits?.find(
    (u) =>
      u?.unitCode === unitData?.primaryUnitCode
  ); 

const handleUnitName=(unitData)=>{
  handleUnitNameSelect(unitData,settings);
}

  const handleMDateChange = (selectedDate) => {
    if (!selectedDate) return;

    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);

    setProductData((prev) => ({
      ...prev,
      manufacturedate: indiaTime,
    }));
    setMDate(indiaTime);
    setExpireMinDate(indiaTime);
  };

  const handleEDateChange = (selectedDate) => {
    if (!selectedDate) return;

    const iso = selectedDate.toISOString();
    const indiaTime = DateConverter.convertToTimeZone(iso, isUser?.timezone);
    setProductData((prev) => ({
      ...prev,
      expiredate: indiaTime,
    }));
    setEDate(indiaTime);
  };

  const handleToggleChange = (key) => {
    setToggles((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleSearchProduct = (term) => {
    if (hasPermission("STOCK", "PRODUCT:search") || permission === undefined) {
      setSearchTerm(term);
      if (term.trim() === "") {
        setProductSugesstions([]);
        searchOpen(false);
        return;
      }
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      if (controllerRef.current) {
        controllerRef.current.abort();
      }
      debounceTimerRef.current = setTimeout(async () => {
        try {
          if (!checkNetwork()) return;
          controllerRef.current = new AbortController();
          const currentId = ++requestIdRef.current;
          const response = await AxiosInstance.get(
            `module/product/search-hybrid-active?searchtxt=${term}`,
            { signal: controllerRef.current.signal },
          );
          if (currentId === requestIdRef.current) {
            setProductSugesstions(response.data.results || []);
            searchOpen(true);
          }
        } catch (error) {
          if (error.name !== "CanceledError" && error.name !== "AbortError") {
            handleError(error, showAlert);
          }
        }
      }, 200);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleSelectNewProduct = (productName) => {
    setShowProductSelect(false);
    setselectedProduct((prev) => ({
      title: productName,
      saleprice: 0,
    }));
    setProductData({
      code: "",
      hsnsac: "",
      title: productName,
      note: "",
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
      quantity: 0,
      landingcost: 0,
      isLock: "SALEPRICE",
      lcmultiplayer: 0,
      finalLandingCost: 0,
      manufacturedate: "",
      expiredate: "",
      shortName:"",
    });
    setApiData({
      code: "",
      hsnsac: "",
      title: productName,
      note: "",
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
      quantity: 0,
      landingcost: 0,
      isLock: "SALEPRICE",
      lcmultiplayer: 0,
      finalLandingCost: 0,
      manufacturedate: "",
      expiredate: "",
      shortName:"",
    })
    setEDate(null);
    setUnitData()
    setMDate(null);
    setImageFile(null);
    setImagePreview("/assets/images/avatars/default.jpg");
  };
  const handleSelectSuggestion = async (product) => {
    try {
      const response = await AxiosInstance.get(
        `module/product/view-product/${product._id}`,
      );
      const fullProduct = response.data?.results || product;
      const finalLandingCost = await getFinalLandingCost(
        fullProduct?.stockLinkId,
        fullProduct?.stockid,
        fullProduct?._id,
      );
      // console.log("finalLandingCost",finalLandingCost)
      setShowProductSelect(true);
      setselectedProduct({...fullProduct,totalStockLeft:product?.totalStockLeft});
      setProductData({
        mrp: CurrencyConverter.toCurrency(fullProduct.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(fullProduct.saleprice, "INR"),
        taxpercentage: fullProduct.taxpercentage,
        discount: CurrencyConverter.toCurrency(fullProduct.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(fullProduct.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(fullProduct.taxamount, "INR"),
        quantity: 0,
        isLock: fullProduct.isLock,
        lcmultiplayer: 0,
        finalLandingCost: CurrencyConverter.toCurrency(finalLandingCost||0, "INR"),
        unitLocked:fullProduct?.unitLocked,
      });
      setApiData({
        mrp:fullProduct.mrp,
        saleprice: fullProduct.saleprice,
        baseprice: fullProduct.baseprice,
      })
      baseRef.current = {
        mrp: fullProduct.mrp/100,
        saleprice: fullProduct.saleprice/100,
        baseprice: fullProduct.baseprice/100,
      };
      if(fullProduct?.unitConfig){
      const name=handleUnitName(fullProduct?.unitConfig)
      setUnitData({...fullProduct?.unitConfig,
        primaryUnitName:name?.primaryUnitName,
        secondaryUnitName:name?.secondaryUnitName,
      })}else{
        setUnitData()
      }
      setEDate(null);
      setMDate(null);
      setSearchTerm("");
      setProductSugesstions([]);
      searchOpen(false);
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const isSecondaryUnit=()=>{
    if(unitData?.primaryUnitCode===selectedUnit){
      return false;
    }else if(unitData?.secondaryUnitCode===selectedUnit){
      return true;
    }else{
      return false;
    }
  }

  const handleCloseUnit=()=>{
    setAddUnitopen(false);
    setGlobelPopupOpen(false);
    productCodeRef.current.focus();
  }
  const handleSelectBrand = (item) => {
    setBrandData((prev) => ({
      ...prev,
      title: item?.title,
      _id: item?._id,
    }));
  
    setShowSuggestions(false);
  };
  const handleBrandKeyDown = (e) => {
    const value=searchTerm?.trim();
    const hasAddOption = searchTerm?.trim() !== "" && filteredBrand?.length === 0;
  
    const totalItems = hasAddOption ? 1 : filteredBrand?.length;
  
    // if (totalItems === 0) return;
    if(filteredBrand?.length===0){
      if(e.key === "Enter" && value!==""){
        e.preventDefault();
        handleBrandAdd(value);
        setShowSuggestions((prev) => !prev);
        productNoteRef.current?.focus();
        }
        return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setBrandIndex((prev) =>
        prev < totalItems - 1 ? prev + 1 : 0
      );
    }
  
    if (e.key === "ArrowUp") {
      e.preventDefault();
      setBrandIndex((prev) =>
        prev > 0 ? prev - 1 : totalItems - 1
      );
    }
  
    if (e.key === "Enter") {
      e.preventDefault();
      if(value==="" && brandIndex===-1){
        setShowSuggestions((prev) => !prev);
        productNoteRef.current?.focus();
        return;
      }
      //  ADD NEW
      if (hasAddOption && brandIndex === 0) {
        handleBrandAdd(searchTerm);
        productNoteRef.current?.focus();
        return;
      }
  
      //  SELECT EXISTING
      if (brandIndex >= 0 && filteredBrand[brandIndex]) {
        handleSelectBrand(filteredBrand[brandIndex]);
        productNoteRef.current?.focus();
      }
    }
  };

  const getFinalLandingCost = async (stocklinkid, stockid, productid) => {
    try {
      if (!checkNetwork()) return;

      const params = new URLSearchParams();

      // always add productid
      params.append("productid", productid);

      // add stockid only if not null/undefined/empty
      if (stockid !== null && stockid !== undefined && stockid !== "") {
        params.append("stockid", stockid);
      }

      // add stocklinkid only if not null/undefined/empty
      if (
        stocklinkid !== null &&
        stocklinkid !== undefined &&
        stocklinkid !== ""
      ) {
        params.append("stocklinkid", stocklinkid);
      }

      const response = await AxiosInstance.get(
        `module/stock/final-landingcost?${params.toString()}`,
      );
      // const response = await AxiosInstance.get(`module/stock/final-landingcost?${stocklinkid}
      // &stockid=${stockid}&productid=${productid}`);
      return response.data?.results?.finalLandingCost;
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleCalculate = (updatedData) => {
    var { mrp, saleprice, baseprice, taxpercentage } = updatedData;
    baseRef.current = {
      mrp,
      saleprice,
      baseprice,
    };

    // let numericMrp = CurrencyConverter.toSubunit(mrp || 0, "INR");
    // let numericSaleprice = CurrencyConverter.toSubunit(saleprice || 0, "INR");
    // let numericBaseprice = CurrencyConverter.toSubunit(baseprice || 0, "INR");
    let numericMrp = CurrencyConverter.toSubunit(baseRef.current.mrp || 0, "INR");
    let numericSaleprice = CurrencyConverter.toSubunit(baseRef.current.saleprice || 0, "INR");
    let numericBaseprice = CurrencyConverter.toSubunit(baseRef.current.baseprice || 0, "INR");
    let numericTaxpercentage = parseInt(taxpercentage);
    let quanity = parseInt(1);
    let calculationResult;
    let lock = isProductData.isLock;
    try {
      calculationResult =getAllPriceList(
        numericMrp,
        numericSaleprice,
        numericBaseprice,
        numericTaxpercentage,
        quanity,
        lock,
      );

      if (lock === "SALEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setProductData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            baseprice: CurrencyConverter.toCurrency(
              calculationResult.basePrice,
              "INR",
            ),
          }));
          baseRef.current={
            mrp:calculationResult.mrp/100,
            saleprice:calculationResult.salePrice/100,
            baseprice:calculationResult.basePrice/100,
          }
          if (!unitData) {
            // no unit → normal
            setApiData((prevData) => ({
              ...prevData,
              mrp: calculationResult.mrp,
              discount: calculationResult.discount,
              taxamount: calculationResult.gstAmount,
              baseprice: calculationResult.basePrice,
              saleprice: calculationResult.salePrice,
            }));
          } else {
            // ✅ ALWAYS store API in PRIMARY UNIT
            // const primary = toPrimaryUnitPrice(
            //   calculationResult.mrp,
            //   calculationResult.salePrice,
            //   calculationResult.basePrice,
            //   numericTaxpercentage,
            //   1,
            //   lock,
            //   unitData
            // );
            let primary;

            if (selectedUnit === unitData?.secondaryUnitCode) {
              const converted = toPrimaryUnitPrice(
                calculationResult.mrp,
                calculationResult.salePrice,
                calculationResult.basePrice,
                numericTaxpercentage,
                1,
                lock,
                unitData,
              );
            
              primary = converted;
            } else {
             
              primary = {
                primaryUnitPrice: calculationResult,
              };
            }
            setApiData((prevData) => ({
              ...prevData,
              mrp: primary?.primaryUnitPrice?.mrp,
              discount: primary?.primaryUnitPrice?.discount,
              taxamount: primary?.primaryUnitPrice?.taxAmount,
              baseprice: primary?.primaryUnitPrice?.basePrice,
              saleprice: primary?.primaryUnitPrice?.salePrice,
            }));
          }
        }
        setProductData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          baseprice: CurrencyConverter.toCurrency(
            calculationResult.basePrice,
            "INR",
          ),
        }));
        baseRef.current={
          mrp:calculationResult.mrp/100,
          saleprice:calculationResult.salePrice/100,
          baseprice:calculationResult.basePrice/100,
        }
        if (!unitData) {
          // no unit → normal
          setApiData((prevData) => ({
            ...prevData,
            mrp: calculationResult.mrp,
            discount: calculationResult.discount,
            taxamount: calculationResult.gstAmount,
            baseprice: calculationResult.basePrice,
            saleprice: calculationResult.salePrice,
          }));
        } else {
          let primary;

          if (selectedUnit === unitData?.secondaryUnitCode) {
            const converted = toPrimaryUnitPrice(
              calculationResult.mrp,
              calculationResult.salePrice,
              calculationResult.basePrice,
              numericTaxpercentage,
              1,
              lock,
              unitData,
            );
          
            primary = converted;
          } else {
           
            primary = {
              primaryUnitPrice: calculationResult,
            };
          }
        
          setApiData((prevData) => ({
            ...prevData,
            mrp: primary?.primaryUnitPrice?.mrp,
            discount: primary?.primaryUnitPrice?.discount,
            taxamount: primary?.primaryUnitPrice?.taxAmount,
            baseprice: primary?.primaryUnitPrice?.basePrice,
            saleprice: primary?.primaryUnitPrice?.salePrice,
          }));
        }
      } else if (lock === "BASEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setProductData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            saleprice: CurrencyConverter.toCurrency(
              calculationResult.salePrice,
              "INR",
            ),
          }));
          baseRef.current={
            mrp:calculationResult.mrp/100,
            saleprice:calculationResult.salePrice/100,
            baseprice:calculationResult.basePrice/100,
          }
          if (!unitData) {
            // no unit → normal
            setApiData((prevData) => ({
              ...prevData,
              mrp: calculationResult.mrp,
              discount: calculationResult.discount,
              taxamount: calculationResult.gstAmount,
              baseprice: calculationResult.basePrice,
              saleprice: calculationResult.salePrice,
            }));
          } else {
            let primary;

            if (selectedUnit === unitData?.secondaryUnitCode) {
              const converted = toPrimaryUnitPrice(
                calculationResult.mrp,
                calculationResult.salePrice,
                calculationResult.basePrice,
                numericTaxpercentage,
                1,
                lock,
                unitData,
              );
            
              primary = converted;
            } else {
             
              primary = {
                primaryUnitPrice: calculationResult,
              };
            }
          
            setApiData((prevData) => ({
              ...prevData,
              mrp: primary?.primaryUnitPrice?.mrp,
              discount: primary?.primaryUnitPrice?.discount,
              taxamount: primary?.primaryUnitPrice?.taxAmount,
              baseprice: primary?.primaryUnitPrice?.basePrice,
              saleprice: primary?.primaryUnitPrice?.salePrice,
            }));
          }
        }
        setProductData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          saleprice: CurrencyConverter.toCurrency(
            calculationResult.salePrice,
            "INR",
          ),
        }));
        baseRef.current={
          mrp:calculationResult.mrp/100,
          saleprice:calculationResult.salePrice/100,
          baseprice:calculationResult.basePrice/100,
        }
        if (!unitData) {
          // no unit → normal
          setApiData((prevData) => ({
            ...prevData,
            mrp: calculationResult.mrp,
            discount: calculationResult.discount,
            taxamount: calculationResult.gstAmount,
            baseprice: calculationResult.basePrice,
            saleprice: calculationResult.salePrice,
          }));
        } else {
          let primary;

            if (selectedUnit === unitData?.secondaryUnitCode) {
              const converted = toPrimaryUnitPrice(
                calculationResult.mrp,
                calculationResult.salePrice,
                calculationResult.basePrice,
                numericTaxpercentage,
                1,
                lock,
                unitData,
              );
            
              primary = converted;
            } else {
             
              primary = {
                primaryUnitPrice: calculationResult,
              };
            }
        
          setApiData((prevData) => ({
            ...prevData,
            mrp: primary?.primaryUnitPrice?.mrp,
            discount: primary?.primaryUnitPrice?.discount,
            taxamount: primary?.primaryUnitPrice?.taxAmount,
            baseprice: primary?.primaryUnitPrice?.basePrice,
            saleprice: primary?.primaryUnitPrice?.salePrice,
          }));
        }
      }
    } catch (error) {
      showAlert("warning", error.message || Messages.ERROR.INVALID_INPUT);
    }
  };

  // const handleSuggestUnit = async () => {
  //   try {
  //     if (!checkNetwork()) return;
  //     const response = await AxiosInstance.get(`module/unit`);

  //     setUnitSuggest(response.data.results || []);
  //     // setShowtitlePopup(true);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const handleUnit = (payload) => {
    handleUnitselect(payload,setUnitData,setPayloadData,setUnitSuggest);
  }

//   const handleChange = (e) => {
//     setErrors("");
//     const { name, value } = e.target;
//     let inputValue = value;

//     if (
//       name === "mrp" ||
//       name === "saleprice" ||
//       name === "baseprice" ||
//       name === "landingcost"
//     ) {
//       const regex = /^$|^\d*\.?\d{0,2}$/;
//       if (!regex.test(value)) {
//         return;
//       }
//       inputValue = value;
//     }

//     if (name === "hsnsac") {
//       // allow empty
//       if (value === "") {
//         inputValue = "";
//       } else {
//         // exactly 6 digits
//         const regex = /^\d{0,8}$/;
//         if (!regex.test(value)) {
//           return; //  block invalid typing
//         }
//         inputValue = value;
//       }
//     }

//     if (name === "taxpercentage") {
//       const allowedValues = [0, 5, 12, 18, 24];
//       if (!allowedValues.includes(Number(value))) inputValue = 0;
//     }

//     if (name === "note") {
//       // Filter suggestions dynamically
//       if (value.trim() === "") {
//         setFilteredNoteSuggestions(noteSuggest);
//         setShowNotePopup(false);
//         noteOpenStatus(false);
//       } else {
//         const filtered = {};

//         Object.entries(noteSuggest).forEach(([category, items]) => {
//           const matched = items.filter((item) =>
//             item.toLowerCase().includes(value.toLowerCase()),
//           );
//           if (matched.length > 0) {
//             filtered[category] = matched;
//           }
//         });

//         setFilteredNoteSuggestions(filtered);
//         setShowNotePopup(Object.keys(filtered).length > 0);
//         noteOpenStatus(Object.keys(filtered).length > 0);
//       }

//       setHighlightedIndex(-1);
//     }
//  if (name === "brandName") {
//       const valueLower = value.toLowerCase();
    
//       // always start from full list
//       let baseList = brandSuggest || [];
    
//       if (value.trim() === "") {
//         setFilteredBrand(baseList); // reset to full list
//       } else {
//         const filtered = baseList?.filter((item) =>
//           item?.title?.toLowerCase().includes(valueLower)
//         );
//         setFilteredBrand(filtered);
//       }
    
//       setBrandIndex(-1);
//       setIsBrandFocused(true); //  ensure dropdown stays open while typing
//     }

//     if (["quantity"].includes(name)) {

//       if (uRLs.UNIT==="true" && unitData) {
//         // allow decimal with max 3 digits
//         if (isSecondaryUnit()) {
//           if (!/^\d*\.?\d{0,1}$/.test(value)) {
//             return;
//           }
//         } else {
//           // primary unit -> allow 3 decimals
//           if (!/^\d*\.?\d{0,3}$/.test(value)) {
//             return;
//           }
//         }
//       } else {
//         // allow only integer
//         if (!/^\d*$/.test(value)) {
//           return;
//         }
//       }
    
//     }
//     if (name === "lcmultiplayer") {
//       const regex = /^$|^\d*\.?\d{0,10}$/;
//       if (!regex.test(value)) {
//         return;
//       }
//       const multiplier = parseFloat(value) || 0;
//       const landing = finance.getFinalLandingCost(
//         multiplier,
//         finance.toSubunit(isProductData.finalLandingCost, "INR"),
//       );
//       // multiplier * (parseFloat(isProductData.finalLandingCost) || 0);
//       const updatedData = {
//         ...isProductData,
//         lcmultiplayer: value,
//         landingcost: finance.toCurrency(landing, "INR"),
//       };

//       localStorage.setItem("lastMultiplier", value);

//       setProductData(updatedData);
//       handleCalculate(updatedData);
//       return;
//     }

//     if (name === "landingcost") {
//       const updatedData = {
//         ...isProductData,
//         landingcost: inputValue,
//         lcmultiplayer: "",
//       };

//       setProductData(updatedData);
//       handleCalculate(updatedData);
//       return;
//     }

//     if (name === "quantity") {
//       const updatedData = {
//         ...isProductData,
//         quantity: inputValue,
//       };
    
//       setProductData(updatedData);
    
//       //  ONLY update API quantity
//       setApiData((prev) => ({
//         ...prev,
//         quantity: Number(inputValue) || 0,
//       }));
    
//       return; //  STOP here (no calculate)
//     }

//     const updatedData = {
//       ...isProductData,
//       [name]: inputValue,
//     };
//     setProductData(updatedData);
//     handleCalculate(updatedData);
//   };

const changeParams ={
  isProductData,
  uRLs,
  unitData,
  clearErrorsOnChange: true,
  noteSuggest,
  brandSuggest,
  setProductData,
  setErrors,
  setFilteredNoteSuggestions,
  setShowNotePopup,
  noteOpenStatus,
  setHighlightedIndex,
  setFilteredBrand,
  setBrandIndex,
  setIsBrandFocused,
  handleCalculate,
  validateField:()=>{},
  // Variant C extras:
  isSecondaryUnit,
  finance,
  setApiData,
}

  const handleRadioChange = (inputName) => {
    // setSelectedRadio(inputName);
    setProductData((prev) => ({
      ...prev,
      isLock: inputName,
    }));
  };

  const isValidDate = (date) => {
    const d = new Date(date);
    return !isNaN(d.getTime());
  };

  const onAdd = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (selectedProduct._id) {
      const updatedData = {
        ...isProductData,
        mrp:isApiData?.mrp,
        saleprice:isApiData?.saleprice,
        baseprice:isApiData?.baseprice,
        quantity:isApiData?.quantity,
        manufacturedate: manufacturedate
          ? new Date(manufacturedate).toISOString()
          : null,
        expiredate: expiredate ? new Date(expiredate).toISOString() : null,
      };
      handleAdd(updatedData);
    } else {
      onProductAdd(e);
    }
    // resetForm();
  };

  const resetForm = () => {
    setProductData({
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
      quantity: 0,
      landingcost: 0,
      isLock: "SALEPRICE",
    });
    setApiData({
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
      quantity: 0,
      landingcost: 0,
      isLock: "SALEPRICE",
    })
    setTags([]);
    setBrandData({
      title:"",
      _id:'',
    })
    setErrors("");
    searchRef.current?.focus();
    setselectedProduct(null);
    setUnitData() 
    setPayloadData()
    // setSelectedRadio("SALEPRICE");
    setEDate(null);
    setMDate(null);
    setImageFile(null);
    setImagePreview("/assets/images/avatars/default.jpg");
  };

  const validateForm = () => {
    const errors = {};
    // if (!selectedProduct || !selectedProduct._id) {

    if (!selectedProduct._id) {
      if (!isProductData.title) {
        errors.title = Messages.ERROR.TITLE_EMPTY;
        productTitleRef.current?.focus();
      } else if (!isProductData.code) {
        productCodeRef.current?.focus();
        errors.code = Messages.ERROR.CODE_EMPTY;
      } else if (isProductData.code && !/^[^\s]*$/.test(isProductData.code)) {
        errors.name = Messages.ERROR.INVALID_INPUT;
      } else if (
        isProductData.hsnsac &&
        !/^\d{4,8}$/.test(isProductData.hsnsac)
      ) {
        errors.hsnsac = Messages.ERROR.INVALID_PRODUCT_HSN_SAC;
      }
    }
    if (!selectedProduct) {
      errors.productid = Messages.ERROR.PRODUCTID_EMPTY;
    } else if (
      isProductData.saleprice === undefined ||
      isProductData.saleprice === null ||
      isProductData.saleprice === ""
    ) {
      errors.saleprice = Messages.ERROR.SALEPRICE_EMPTY;
      productSalepriceRef.current?.focus();
    } else if (
      isProductData.saleprice &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.saleprice)
    ) {
      errors.saleprice = Messages.ERROR.INVALID_INPUT;
      productSalepriceRef.current?.focus();
    } else if (
      isProductData.taxpercentage === undefined ||
      isProductData.taxpercentage === null ||
      isProductData.taxpercentage === ""
    ) {
      errors.taxpercentage = Messages.ERROR.TAX_EMPTY;
      productTaxpercentageRef.current?.focus();
    } else if (
      isProductData.taxpercentage &&
      !/^[0-9]*$/.test(isProductData.taxpercentage)
    ) {
      errors.taxpercentage = Messages.ERROR.INVALID_INPUT;
      productTaxpercentageRef.current?.focus();
    } else if (
      isProductData.baseprice === undefined ||
      isProductData.baseprice === null ||
      isProductData.baseprice === ""
    ) {
      errors.baseprice = Messages.ERROR.BASEPRICE_EMPTY;
      productBasepriceRef.current?.focus();
    } else if (
      isProductData.baseprice &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.baseprice)
    ) {
      errors.baseprice = Messages.ERROR.INVALID_INPUT;
      productBasepriceRef.current?.focus();
    } else if (
      isProductData.taxamount === undefined ||
      isProductData.taxamount === null ||
      isProductData.taxamount === ""
    ) {
      errors.taxamount = Messages.ERROR.TAXAMOUNT_EMPTY;
    } else if (
      isProductData.taxamount &&
      !/^\d*\.?\d{0,2}$/.test(isProductData.taxamount)
    ) {
      errors.taxamount = Messages.ERROR.INVALID_INPUT;
    } else if (selectedProduct?._id) {
      if (
        isProductData.quantity === undefined ||
        isProductData.quantity === null ||
        isProductData.quantity === ""
      ) {
        errors.quantity = Messages.ERROR.STOCK_EMPTY;
      } else if (Number(isProductData.quantity,10) <= 0.000) {
        errors.quantity = Messages.ERROR.STOCK_INVALID;
      }
    }
    // else if (
    //   isProductData.quantity === undefined ||
    //   isProductData.quantity === null ||
    //   isProductData.quantity === ""
    // ) {
    //   errors.quantity = Messages.ERROR.STOCK_EMPTY;
    //   productMdateRef.current?.focus();
    // }
    else if (isProductData.quantity && !/^\d+$/.test(isProductData.quantity)) {
      errors.quantity = Messages.ERROR.INVALID_INPUT;
      productMdateRef.current?.focus();
    }
    // else if (parseInt(isProductData.quantity, 10) <= 0) {
    //   errors.quantity = Messages.ERROR.STOCK_INVALID;
    //   productMdateRef.current?.focus();
    // }

    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "saleprice":
          productSalepriceRef.current?.focus();
          break;
        case "hsnsac":
          productHsnsacRef.current?.focus();
          break;
        case "taxpercentage":
          productTaxpercentageRef.current?.focus();
          break;
        case "baseprice":
          productBasepriceRef.current?.focus();
          break;
        case "productid":
          searchRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  const handleClose = async () => {
    resetForm();
    navigatelist();
  };


  const onProductAdd = async (e) => {
    e.preventDefault();

    if (hasPermission("PRODUCT", "PRODUCT:add") || permission === undefined) {
      if (!validateForm()) return;

      const formData = new FormData();
      const tagString = tags.join(" ");
      formData.append("code", isProductData.code);
      formData.append("hsnsac", isProductData.hsnsac);
      formData.append("title", isProductData.title);
      formData.append("mrp",isApiData?.mrp,);
      formData.append( "saleprice",isApiData?.saleprice);
      formData.append("taxpercentage", isProductData?.taxpercentage);
      formData.append("discount",isApiData?.discount);
      formData.append("baseprice",isApiData?.baseprice);
      formData.append("taxamount",isApiData?.taxamount);
      formData.append("isLock", isProductData?.isLock);
      formData.append(
        "landingcost",
        CurrencyConverter.toSubunit(isProductData.landingcost || 0, "INR"),
      );
      if(tagString){
        formData.append(
          "searchTag", tagString,
        )}
      formData.append("note", isProductData.note);
      if(brandData?.title){
        formData.append("brandId", brandData?.title)};
        if(isProductData?.shortName){
          formData.append("shortName", isProductData?.shortName)};
      if(payloadData){
        formData.append("unitConfig",JSON.stringify(payloadData))}
        if(isApiData?.quantity||isProductData?.quantity){
        formData.append("openingStock",isApiData?.quantity||isProductData?.quantity)}
      //  Append file only if it exists
      if (imageFile instanceof File) {
        formData.append("primaryImage", imageFile);
      } else {
        console.log("No image selected or wrong data type:", imageFile);
      }
      const allNotes = Object.values(noteSuggest).flat();

      // Clone existing suggestions safely
      let updatedSuggestions = { ...noteSuggest };

      // If the note does not exist anywhere, add it under General
      if (!allNotes.includes(isProductData.note)) {
        // If General category doesn't exist, create it
        if (!updatedSuggestions["General"]) {
          updatedSuggestions["General"] = [];
        }

        // Add the new note to General
        updatedSuggestions["General"] = [
          ...updatedSuggestions["General"],
          isProductData.note,
        ];
      }

      // Update state so UI refreshes immediately
      setNoteSuggest(updatedSuggestions);
      setFilteredNoteSuggestions(updatedSuggestions);

      try {
        await handleAddProduct(formData);
        // resetForm();
      } catch (error) {
        console.error("Upload Error:", error);
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };
  const openEditModal = (cItem) => {
    if (
      hasPermission("PRODUCT", "PRODUCT:update") ||
      permission === undefined
    ) {
      setProductEditData({
        ...cItem,
        mrp: CurrencyConverter.toCurrency(cItem?.mrp, "INR"),
        saleprice: CurrencyConverter.toCurrency(cItem?.saleprice, "INR"),
        discount: CurrencyConverter.toCurrency(cItem?.discount, "INR"),
        baseprice: CurrencyConverter.toCurrency(cItem?.baseprice, "INR"),
        taxamount: CurrencyConverter.toCurrency(cItem?.taxamount, "INR"),
        landingcost: CurrencyConverter.toCurrency(
          cItem?.landingcost || 0,
          "INR",
        ),
      });
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };
  const handleBrandAdd=async(brandName)=>{
    try{
      if (!checkNetwork()) return;
      const response = await AxiosInstance.post(`module/product/brand`,{
        brandName:brandName
      });
      const result=response?.data?.results;

      const newBrand = {
        _id: result?._id,
        title: result?.brandName,
      };

      setBrandSuggest((prev) => {
        // avoid duplicate
        const exists = prev.some((item) => item?.title === newBrand?.title);
        if (exists) return prev;
  
        return [newBrand, ...prev]; //  correct way
      });
      
      setBrandData((prev) => ({
      ...prev,
      title: newBrand.title,
      _id: newBrand._id,
    }));

    setShowSuggestions(false);
    setSearchTerm("");
      return newBrand?.title;
    }catch(error){
      handleError(error, showAlert);
      return false;
    }
  }

  const addTag = (value) => {
    const clean = value.trim().toLowerCase(); // 👈 convert to small letters
  
    if (!clean) return;
  
    if (!tags.includes(clean)) {
      setTags((prev) => [...prev, clean]);
    }
  
    setTagInput("");
  };

  const handleTagKeyDown = (e) => {
    const value = tagInput;
  
    //  ENTER → add tag
    if (e.key === "Enter") {
      e.preventDefault();
      if (value) {
        addTag(value); 
      } else if(toggles["stock"] && viewOption(
        "stockSettings",
        "isManufactureAndExpiryDates",
      )) {
        manufacturedateRefs.current?.focus(); // move to next field
      }else if(toggles["stock"]){
        productMdateRef.current?.focus(); 
      }
      else{
        onAdd(e);
      }
      return;
    }
  
    //  BACKSPACE → remove last tag if input empty
    if (e.key === "Backspace" && !value) {
      setTags((prev) => prev.slice(0, -1));
      return;
    }
  
    //  INVALID KEY → create tag
    const isValidChar = /^[a-zA-Z0-9 .]$/.test(e.key);
  
    if (!isValidChar && e.key.length === 1) {
      e.preventDefault();
      addTag(value);
    }
  };
  
  const removeTag = (index) => {
    setTags(tags.filter((_, i) => i !== index));
  };

  const handleAddProduct = async (formData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.post(
        `module/product/add-product`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      const addProduct = response?.data?.results;
      if(response.data.message==="Product already exist."){
        showAlert("warning",response.data.message)
        openEditModal(addProduct)
      }else{
      showAlert("success", Messages.SUCCESS.PRODUCT_ADDED);
      // handleSetRecentProducts(response?.data?.results);
      setShowProductSelect(true);
      if (isProductData.quantity > 0 && toggles["stock"]) {
        const updatedData = {
          ...isProductData,
          manufacturedate: isValidDate(manufacturedate)
            ? new Date(manufacturedate).toISOString()
            : null,
          expiredate: isValidDate(expiredate)
            ? new Date(expiredate).toISOString()
            : null,
        };
        // await handleAddStock(updatedData, addProduct);
        await ListRecentStock()
      }
    }
    setShowProductSelect(true);
      resetForm();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

 const handleEdit=(updatedData)=>{
  setselectedProduct(updatedData);
      setProductData({
        mrp: CurrencyConverter.toCurrency(updatedData?.mrp||0,"INR"),
        saleprice: CurrencyConverter.toCurrency(updatedData?.saleprice||0,"INR"),
        taxpercentage: updatedData?.taxpercentage,
        discount: CurrencyConverter.toCurrency(updatedData?.discount||0,"INR"),
        baseprice: CurrencyConverter.toCurrency(updatedData?.baseprice||0,"INR"),
        taxamount: CurrencyConverter.toCurrency(updatedData?.taxamount||0,"INR"),
        isLock: updatedData?.isLock,
        lcmultiplayer: 0,
        finalLandingCost: CurrencyConverter.toCurrency(updatedData?.landingcost||0,"INR"),
        unitLocked:updatedData?.unitLocked,
      });
      setApiData({
        mrp:updatedData?.mrp,
        saleprice: updatedData?.saleprice,
        baseprice: updatedData?.baseprice,
      })
      setSelectedUnit(unitData?.primaryUnitCode)
 }
 
  const handleAddStock = async (newStockData, addProduct) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: addProduct._id,
        ...(newStockData?.manufacturedate && {
          manufacturedate: DateConverter.convertToTimeZone(
            newStockData?.manufacturedate,
            isUser?.timezone,
          ),
        }),
        ...(newStockData?.expiredate && {
          expiredate: DateConverter.convertToTimeZone(
            newStockData?.expiredate,
            isUser?.timezone,
          ),
        }),
        mrp: CurrencyConverter.toSubunit(newStockData.mrp, "INR"),
        saleprice: CurrencyConverter.toSubunit(newStockData.saleprice, "INR"),
        taxpercentage: newStockData.taxpercentage,
        // discount: CurrencyConverter.toSubunit(newStockData.discount, "INR"),
        baseprice: CurrencyConverter.toSubunit(newStockData.baseprice, "INR"),
        // taxamount: CurrencyConverter.toSubunit(newStockData.taxamount, "INR"),
        landingcost: CurrencyConverter.toSubunit(
          newStockData.landingcost || 0,
          "INR",
        ),
        isLock: newStockData.isLock,
        quantity: Number(newStockData.quantity),
        isSecondaryUnit:isSecondaryUnit(),
      };
      const response = await AxiosInstance.post(`module/stock`, data);
      showAlert("success", Messages.SUCCESS.STOCK_ADDED);
      const result = response.data.results;
      resetForm();
      handleSetRecentStock(result, addProduct?.title, addProduct?.code);
      setShowProductSelect(true);
      const updatedStock = {
        ...result,
        title: addProduct?.title,
        code: addProduct?.code,
      };

      const previousStocks =
        JSON.parse(localStorage.getItem("recentStocks")) || [];

      const updatedStocks = [updatedStock, ...previousStocks].slice(0, 10); // Store only latest 10

      localStorage.setItem("recentStocks", JSON.stringify(updatedStocks));
      // ListRecentStock();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const primaryQuanity=(quanity)=>{
    const qty=toPrimaryQuantity(quanity, unitData);
    return qty?.primaryQty;
  }

  const handleAdd = async (newStockData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: selectedProduct._id,
        ...(newStockData?.manufacturedate && {
          manufacturedate: DateConverter.convertToTimeZone(
            newStockData?.manufacturedate,
            isUser?.timezone,
          ),
        }),
        ...(newStockData?.expiredate && {
          expiredate: DateConverter.convertToTimeZone(
            newStockData?.expiredate,
            isUser?.timezone,
          ),
        }),
        mrp: newStockData?.mrp,
        saleprice:newStockData?.saleprice,
        taxpercentage: newStockData?.taxpercentage,
        // discount: CurrencyConverter.toSubunit(newStockData.discount, "INR"),
        baseprice: newStockData?.baseprice,
        // taxamount: CurrencyConverter.toSubunit(newStockData.taxamount, "INR"),
        landingcost: CurrencyConverter.toSubunit(
          newStockData.landingcost || 0,
          "INR",
        ),
        isLock: newStockData.isLock,
        quantity: Number(isSecondaryUnit()
        ? primaryQuanity(newStockData.quantity)
        : newStockData.quantity),
        isSecondaryUnit:isSecondaryUnit(),
      };
      setShowProductSelect(true);
      const response = await AxiosInstance.post(`module/stock`, data);
      showAlert("success", Messages.SUCCESS.STOCK_ADDED);
      const result = response.data.results;
      resetForm();
      handleSetRecentStock(
        result,
        selectedProduct?.title,
        selectedProduct?.code,
      );

      const updatedStock = {
        ...result,
        title: selectedProduct?.title,
        code: selectedProduct?.code,
      };

      const previousStocks =
        JSON.parse(localStorage.getItem("recentStocks")) || [];

      const updatedStocks = [updatedStock, ...previousStocks].slice(0, 10); // Store only latest 10

      localStorage.setItem("recentStocks", JSON.stringify(updatedStocks));
      // ListRecentStock();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleGenerateBarcode = async () => {
    if (
      hasPermission("PRODUCT", "PRODUCT:createBarcode") ||
      permission === undefined
    ) {
      setButtonLoading(true);
      try {
        if (!checkNetwork()) return;
        const response = await AxiosInstance.get(`module/product`);
        const newBarcode = response.data.results.barcode;
        setProductData((prevData) => ({
          ...prevData,
          code: newBarcode,
        }));
      } catch (error) {
        handleError(error, showAlert);
        return false;
      } finally {
        setButtonLoading(false);
        productCodeRef.current?.focus();
      }
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleOpenImageModel = () => {
    setGlobelPopupOpen(true);
    seImageModalOpen(true);
  };

  const handleImageClose = () => {
    setGlobelPopupOpen(false);
    seImageModalOpen(false);
  };
  const handleAddImage = (image) => {
    if (image) {
      setImageFile(image);
      setImagePreview(URL.createObjectURL(image));
      handleImageClose();
    }
  };

  const handleOutsideClick = (e) => {
    if (searchRef.current && !searchRef.current.contains(e.target)) {
      setProductSugesstions([]);
      searchOpen(false);
      setSearchTerm("");
    }
  };

  const handleSuggestionNavigation = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const trimmedSearch = searchTerm.trim();

      if (activeIndex >= 0 && isProductSugesstions[activeIndex]) {
        handleSelectSuggestion(isProductSugesstions[activeIndex]);
      }
      // else{
      //   e.preventDefault();
      // }
      else if (trimmedSearch) {
        handleSelectNewProduct(trimmedSearch);
        setSearchTerm("");
        setProductSugesstions([]);
        searchOpen(false);
      }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < isProductSugesstions.length - 1 ? prev + 1 : 0,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : isProductSugesstions.length - 1,
      );
    }
  };
  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    const flatSuggestions = [
      ...(filteredNoteSuggestions["General"]
        ? filteredNoteSuggestions["General"]
        : []),
      ...Object.entries(filteredNoteSuggestions)
        .filter(([category]) => category !== "General")
        .flatMap(([_, items]) => items),
    ];

    if (showNotePopup && flatSuggestions.length > 0) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHighlightedIndex((prev) =>
          prev < flatSuggestions.length - 1 ? prev + 1 : 0,
        );
        return;
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setHighlightedIndex((prev) =>
          prev > 0 ? prev - 1 : flatSuggestions.length - 1,
        );
        return;
      }

      if (e.key === "Enter") {
        e.preventDefault();
        if (highlightedIndex >= 0) {
          const selectedItem = flatSuggestions[highlightedIndex];
          setProductData((prev) => ({
            ...prev,
            note: selectedItem,
          }));
          setShowNotePopup(false);
          noteOpenStatus(false);
          setHighlightedIndex(-1);

          setTimeout(() => {
            // nextRef?.current?.focus();
          }, 100);
          return;
        }
      }
    }
    if (e.key === "Enter") {
      e.preventDefault();

      const code = String(isProductData["code"] || "").trim();
      if (fieldName === "code") {
        if (!code) {
          handleGenerateBarcode();
          setTimeout(() => {
            nextRef?.current?.focus();
          }, 100);
        } else {
          productHsnsacRef?.current?.focus();
        }
        return;
      }

      if (fieldName === "generate") {
        setTimeout(() => {
          nextRef?.current?.focus();
        }, 100);
        return;
      }

      if (fieldName === "title") {
        if (!isProductData.title?.trim()) {
          setErrors((prev) => ({
            ...prev,
            title: Messages.ERROR.TITLE_EMPTY,
          }));
          productTitleRef.current?.focus();
          return;
        } else {
          setErrors((prev) => {
            const { title, ...rest } = prev;
            return rest;
          });
        }
        setTimeout(() => {
          nextRef?.current?.focus();
        }, 100);
        return;
      }

      const trimmedData = String(isProductData[fieldName] || "").trim();
      const requiredFields = ["quantity"];

      // if (requiredFields.includes(fieldName) && !trimmedData) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     [fieldName]:
      //       Messages.ERROR[`${fieldName.toUpperCase()}_EMPTY`] || "Required",
      //   }));
      //   return;
      // }

      if (isLast) {
        onAdd(e);
      } else {
        const nextInput =
          nextRef?.current?.input ||
          nextRef?.current?.flatpickr?.input ||
          nextRef?.current?.querySelector?.("input") ||
          nextRef?.current;

        if (nextInput && typeof nextInput.focus === "function") {
          nextInput.focus();
        } else {
          console.warn("Cannot focus nextRef:", nextRef);
        }
      }
    }
  };

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionNoteRef.current[highlightedIndex]) {
      suggestionNoteRef.current[highlightedIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightedIndex]);

  const flatSuggestions = [
    ...(filteredNoteSuggestions["General"]
      ? filteredNoteSuggestions["General"]
      : []),
    ...Object.entries(filteredNoteSuggestions)
      .filter(([category]) => category !== "General")
      .flatMap(([_, items]) => items),
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowNotePopup(false);
        noteOpenStatus(false);
        setHighlightedIndex(-1);
      }
      setIsAnyInputFocused(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(()=>{
    if(productStockData){
    handleEdit(productStockData)}
  },[productStockData])
  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  useEffect(() => {
    searchRef.current?.focus();
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (data) {
      handleSelectSuggestion(data);
    }
  }, [data]);

  useEffect(() => {
    if (showSuggestions) {
      setFilteredSuggestions(brandSuggest);
    }
  }, [brandSuggest, showSuggestions]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (primaryRef.current && !primaryRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }

    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);
 
useEffect(() => {
  if (brandIndex >= 0) {
    itemRefs.current[brandIndex]?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  }
}, [brandIndex]);

  useEffect(() => {
    const savedMultiplier = localStorage.getItem("lastMultiplier");
    if (isProductData.lcmultiplayer) {
      const multiplier = parseFloat(savedMultiplier) || 0;
      const landing = finance.getFinalLandingCost(
        multiplier,
        finance.toSubunit(isProductData.finalLandingCost, "INR"),
      );

      const updatedData = {
        ...isProductData,
        lcmultiplayer: savedMultiplier,
        landingcost: finance.toCurrency(landing, "INR"),
      };

      setProductData(updatedData);
      handleCalculate(updatedData);
    }
  }, [selectedProduct]);

  useEffect(() => {
    return () => {
      localStorage.setItem("lastMultiplier", 1);
    };
  }, []);

  useEffect(() => {
    if (!isActive) return;

    // small timeout ensures DOM is visible after tab switch
    const timer = setTimeout(() => {
      searchRef.current?.focus();
    }, 0);

    return () => clearTimeout(timer);
  }, [isActive]);

  useEffect(() => {
    if (selectedProduct?._id) {
      productMrpRef.current?.focus();
    } else {
      productTitleRef.current?.focus();
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (
      noteSuggests &&
      typeof noteSuggests === "object" &&
      Object.keys(noteSuggests).length > 0
    ) {
      setNoteSuggest(noteSuggests);
    }
  }, [noteSuggests]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    // handleSuggestUnit();
    setUnitSuggest({
      defaultUnits: settings?.defaultUnits || [],
      storeUnits: settings?.storeUnits || []
    })
  }, []);

  useEffect(()=>{
    setSelectedUnit(unitData?.primaryUnitCode)
  },[unitData])

  return (
    <>
      <div className="card mt-3">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-sm-12" style={{ position: "relative" }}>
              {/* <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  name="search"
                  autoComplete="off"
                  ref={searchRef}
                  value={searchTerm}
                  onChange={(e) => {
                    handleSearchProduct(e.target.value);
                    setActiveIndex(-1);
                  }}
                  onKeyDown={handleSuggestionNavigation}
                  placeholder="Search products by code, hsnsac, title..."
                />
                <button 
                  className={`input-group-text ${
                    searchTerm.trim() ? "bg-label-prime" : ""
                  }`}
                  onClick={
                    searchTerm.trim()
                      ? () => handleSelectNewProduct(searchTerm.trim())
                      : null
                  }
                >
                  <i
                    className={`bx ${
                      searchTerm.trim() ? "bx-plus" : "bx-search"
                    }`}
                  ></i>
                </button>
              </div> */}
              <SearchInput
                searchRef={searchRef}
                value={searchTerm}
                onChange={(e) => {
                  handleSearchProduct(e.target.value);
                  setActiveIndex(-1);
                }}
                onSearch={
                  searchTerm.trim()
                    ? () => handleSelectNewProduct(searchTerm.trim())
                    : null
                }
                placeholder="Search products by code, hsnsac, title..."
                onKeyDown={handleSuggestionNavigation}
              />
              {searchTerm && isProductSugesstions.length === 0 && (
                <ul className="suggestions-list">
                  <li className="suggestion-item text-muted">
                    No search results found
                  </li>
                </ul>
              )}
              {isProductSugesstions.length > 0 && (
                <ProductSearchList suggest={isProductSugesstions}
                suggestionRefs={suggestionRefs}
                 handleSelect={handleSelectSuggestion} activeIndex={activeIndex}
                 />
              )}
              {error.productid && (
                <div className="invalid-feedback">{error.productid}</div>
              )}
            </div>
            {showProductSelect && (
              <div className="col-lg-12 mt-2">
                <div className="card shadow-none border-blue mb-0">
                  <div className="card-header bg-light-blue p-2 d-flex justify-content-between align-items-center">
                    <div className="mb-0">Product info</div>
                      {selectedProduct?._id && (
                          <div className="order-actions  opacity-md-100">
                            <button
                              type="button"
                              className="btn-label-primary shadow-none"
                              onClick={() =>
                              openEditModal(selectedProduct)}
                            >
                              <EditIcon/>
                            </button>
                          </div>
                        )}
                  </div>
                  <div className="card-body p-2">
                    {selectedProduct?._id ? (
                      <div>
                        {/* <p className="mb-1">
                          Title :{" "}
                          <span className="fw-600">
                            {selectedProduct?.title}
                          </span>
                        </p>
                        <p className="mb-1">
                          HSN :{" "}
                          {selectedProduct?.hsnsac ? (
                            <span className="fw-600">
                              {selectedProduct?.hsnsac}
                            </span>
                          ) : (
                            <>-</>
                          )}
                        </p> */}
                        {/* <p className="mb-1">
                          SalePrice :{" "}
                          <span className="fw-600">
                            ₹
                            {CurrencyConverter.toCurrency(
                              selectedProduct?.saleprice || 0,
                              "INR"
                            )}{" "}
                          </span>
                        </p> */}
                        <div className="d-flex ">
                          <div
                            className="mb-1 d-flex  gap-2"
                            style={{ flexBasis: "100%" }}
                          >
                            <span className="fw-semibold text-muted">Title:</span>
                            {selectedProduct?.title ? (
                              <span className="fw-600">
                                {selectedProduct?.title}
                              </span>
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                         <div className="d-flex ">
                         <div
                            className="mb-1 d-flex align-items-center gap-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <span className="fw-semibold text-muted">SKU Code:</span>
                            {selectedProduct?.code ? ( 
                              <span className="badge rounded-pill bg-label-navy">
                                {selectedProduct?.code}
                              </span>
                            ) : (
                              "-"
                            )}
                          </div>
                          <div
                            className="mb-1 d-flex align-items-center gap-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <span className="fw-semibold text-muted">HSN:</span>
                            {selectedProduct?.hsnsac ? (
                              <span className="badge rounded-pill bg-label-retro">
                                {selectedProduct.hsnsac}
                              </span>
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                        <div className="d-flex ">
                        <div
                            className="mb-1 d-flex align-items-center gap-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <span className="fw-semibold text-muted">Brand:</span>
                            {selectedProduct?.brandId ? ( 
                              <span className="badge bg-label-kids">
                                {selectedProduct?.brandId}
                              </span>
                            ) : (
                              "-"
                            )}
                          </div>
                          <div
                            className="mb-1 d-flex align-items-center gap-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <span className="fw-semibold text-muted">Total Stock Left:</span>
                            {selectedProduct?.totalStockLeft ? (
                              <span className="badge bg-label-space">
                                {selectedProduct.totalStockLeft}
                              </span>
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                        <div className="d-flex ">
                        <div
                            className="mb-1 d-flex align-items-center gap-2"
                            style={{ flexBasis: "50%" }}
                          >
                            <span className="fw-semibold text-muted">Note:</span>
                            {selectedProduct?.note ? ( 
                              <span className="badge bg-label-sun">
                                {selectedProduct?.note}
                              </span>
                            ) : (
                              "-"
                            )}
                          </div>
                          {uRLs.UNIT==="true" && (
                                  <div
                                    className="mb-2 d-flex align-items-center gap-2"
                                    style={{ flexBasis: "50%" }}
                                  >
                                    <span className="fw-semibold text-muted">Unit:</span>
                                    {defaultConversion?.unitName ? ( 
                                      <span className="badge rounded-pill btn-unit">
                                        {defaultConversion?.unitName} ({defaultConversion.unitCode})
                                      </span>
                                    ) : (
                                      "-"
                                    )}
                                  </div>)}
                          </div>
                      </div>
                      
                    ) : (
                      <p className="mb-0 text-muted">
                        No products has been selected
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}
            {selectedProduct ? (
              <>
                {!selectedProduct?._id && (
                  <>
                    {/* {uRLs.ADD_PRODUCT_IMAGE === "true" &&
                      (viewOption("productSettings", "isPrimaryImage") ||
                        viewOption("generalSettings", "isProductImage")) && (
                        <div className="col-3 ">
                          <div className=" pb-0">
                            <div className="row g-3">
                              <div className="">
                                <div className="">
                                  <div
                                    className="profile-img-container"
                                    onClick={handleOpenImageModel}
                                  >
                                    <img
                                      id="logoimg"
                                      className="avatar"
                                      src={imagePreview}
                                      alt="profile-img"
                                      style={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: "2px solid #ddd",
                                      }}
                                    />
                                    <div
                                      className="overlay-icon"
                                      onClick={() =>
                                        document
                                          .getElementById("logo_image_popup")
                                          .click()
                                      }
                                    >
                                      <i className="bx bx-plus"></i>
                                    </div>
                                  </div>
                                </div>

                                <input
                                  id="logo_image_popup"
                                  onClick={handleOpenImageModel}
                                  style={{ display: "none" }}
                                  disabled={isUploading}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )} */}
                    <div
                      className={
                       uRLs.UNIT==='true'?
                           "col-8" : "col-12"
                      }
                    >
                      <label htmlFor="title" className="form-label">
                        Title <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        autoComplete="off"
                        ref={productTitleRef}
                        value={isProductData?.title}
                        onChange={(e) => handleChange(e, changeParams)}
                        onFocus={() => setIsAnyInputFocused(true)}
                        onKeyDown={(e) =>
                          handleEnterKey(e, "title", productCodeRef)
                        }
                      />
                      {error.title && (
                        <div className="invalid-feedback">{error.title}</div>
                      )}
                    </div>
                    {uRLs.UNIT==='true' &&(
                <div className="col-4">
                <label htmlFor="unit" className="form-label">
                Unit  <span
                                    className="ms-1"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="right"
                                    title="Unit cannot be edited once stock has been added for this product."
                                    style={{ cursor: "pointer", fontWeight: "bold" }}
                                  >
                                    <ErrorCircleIcon/>{" "}
                                  </span>
                </label>
                  <div className="d-flex align-items-center">
                      <button
                        type="button"
                        className="btn btn-unit fs-10 w-100 d-flex align-items-center justify-content-between"
                        onClick={()=>{setAddUnitopen(true);setGlobelPopupOpen(true);}}
                        
                      >
                        {unitData?.primaryUnitName ? 
                         <><span>{unitData?.primaryUnitName}</span><i className="ng ng-ng-edit-icon me-1" style={{marginTop:"2px"}}></i></> 
                        :
                        <><span>Unit</span> <AddIcon iClass={"me-1"}/></>}
                      </button></div>
                      {unitData &&(
                      <span>1 {unitData?.primaryUnitCode} = {unitData?.secondaryUnitCode ?`${unitData?.conversion} ${unitData?.secondaryUnitCode}`:'1 Unit'}</span>
                      )}
                      </div>
                      
                      )}
                    <div className="col-lg-8 col-xl-8 col-md-6 col-sm-6">
                      <label htmlFor="phone" className="form-label">
                        Barcode / SKU / Code{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <div className="d-flex align-items-center justify-content-between">
                        <input
                          type="text"
                          className="form-control me-2"
                          name="code"
                          autoComplete="off"
                          ref={productCodeRef}
                          value={isProductData.code}
                          onFocus={() => setIsAnyInputFocused(true)}
                          onInput={(e) => handleChange(e, changeParams)}
                          onKeyDown={(e) =>
                            handleEnterKey(e, "code", productCodeGenerate)
                          }
                        />
                        <div className="d-inline-block">
                          {isButtonLoading ? (
                            <button className="btn btn-primary pb-0" disabled>
                              <CircularProgress
                                size={22}
                                className="text-white"
                              />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-primary fs-10 d-flex align-items-center"
                              onClick={handleGenerateBarcode}
                              ref={productCodeGenerate}
                              onFocus={() => setIsAnyInputFocused(true)}
                              onKeyDown={(e) =>
                                handleEnterKey(e, "generate", productHsnsacRef)
                              }
                            >
                              <BarcodeIcon iClass={"me-1"}/> Generate
                            </button>
                          )}
                        </div>
                      </div>
                      {error.code && (
                        <div className="invalid-feedback">{error.code}</div>
                      )}
                    </div>
                    <div className="col-lg-4 col-xl-4 col-md-6 col-sm-6">
                      <label htmlFor="hsnsac" className="form-label">
                        {" "}
                        HSN/SAC{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="hsnsac"
                        autoComplete="off"
                        ref={productHsnsacRef}
                        value={isProductData.hsnsac}
                        onFocus={() => setIsAnyInputFocused(true)}
                        onChange={(e) => handleChange(e, changeParams)}
                        onKeyDown={(e) =>
                          handleEnterKey(e, "hsnsac", productMrpRef)
                        }
                      />
                      {error.hsnsac && (
                        <div className="invalid-feedback">{error.hsnsac}</div>
                      )}
                    </div>
                  </>
                )}
                <div className="col-12 border-top ">
                          <div className="fw-600 mt-2">
                            Amount {selectedUnit ? 
                              (<span className="">
                                  (Per {selectedUnit})
                                </span>
                              ) : ("")}
                          </div>
                        </div>
                <div className="col-lg-4">
                  <label htmlFor="mrp" className="form-label">
                    {" "}
                    MRP{" "}
                  </label>
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control"
                      name="mrp"
                      autoComplete="off"
                      ref={productMrpRef}
                      value={isProductData.mrp}
                      onFocus={(e) => {
                        e.target.select();
                        setIsAnyInputFocused(true);
                      }}
                      onChange={(e) => handleChange(e, changeParams)}
                      onKeyDown={(e) =>
                        handleEnterKey(e, "mrp", productSalepriceRef)
                      }
                      onClick={() => {
                        setPopupMrpValue(isProductData.mrp);
                        setShowMrpPopup(true);
                      }}
                    />
                    {showMrpPopup && (
                      <input
                        type="text"
                        ref={popupMrpInputRef}
                        value={popupMrpValue}
                        onChange={(e) => {
                          const val = e.target.value;
                          const regex = /^\d+(\.\d{0,2})?$/;
                          if (val === "" || regex.test(val)) {
                          setPopupMrpValue(val);
                          setProductData((prev) => ({ ...prev, mrp: val }));
                          handleCalculate({ ...isProductData, mrp: val });
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            setShowMrpPopup(false);
                            setTimeout(() => {
                              productSalepriceRef?.current?.focus();
                            }, 0);
                          }
                        }}
                        onBlur={() => setShowMrpPopup(false)}
                        autoFocus
                        onFocus={(e) => e.target.select()}
                        className="form-control position-absolute "
                        style={{
                          inset: 0, //  THIS is the key
                          zIndex: 10,
                        }}
                      />
                    )}
                  </div>
                  {error.mrp && (
                    <div className="invalid-feedback">{error.mrp}</div>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="saleprice" className="form-label">
                    Sale Price <span className="text-danger">*</span>
                  </label>
                  <div className="input-container position-relative">
                    <input
                      type="text"
                      name="saleprice"
                      autoComplete="off"
                      ref={productSalepriceRef}
                      value={isProductData.saleprice}
                      className="form-control"
                      onFocus={(e) => {
                        e.target.select();
                        setIsAnyInputFocused(true);
                      }}
                      onClick={() => handleRadioChange("SALEPRICE")}
                      style={{ paddingLeft: "30px" }}
                      onChange={(e) => handleChange(e, changeParams)}
                      onKeyDown={(e) =>
                        handleEnterKey(e, "saleprice", productTaxpercentageRef)
                      }
                    />
                    <input
                      type="radio"
                      name="priceLock"
                      checked={isProductData?.isLock === "SALEPRICE"}
                      onChange={() => handleRadioChange("SALEPRICE")}
                      className="position-absolute"
                      style={{
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        zIndex: 2,
                      }}
                    />
                  </div>
                  {error.saleprice && (
                    <div className="invalid-feedback">{error.saleprice}</div>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="taxpercentage" className="form-label">
                    Tax(%) <span className="text-danger">*</span>
                  </label>
                  <select
                    name="taxpercentage"
                    className="form-control"
                    ref={productTaxpercentageRef}
                    value={isProductData.taxpercentage}
                    onChange={(e) => handleChange(e, changeParams)}
                    onFocus={() => setIsAnyInputFocused(true)}
                    onKeyDown={(e) =>
                      handleEnterKey(e, "taxpercentage", productBasepriceRef)
                    }
                  >
                    <option value="0">0</option>
                    <option value="5">5</option>
                    <option value="12">12</option>
                    <option value="18">18</option>
                    <option value="24">24</option>
                  </select>
                </div>

                <div className="col-lg-4">
                  <label htmlFor="discount" className="form-label">
                    Discount
                  </label>
                  <input
                    readOnly=""
                    type="text"
                    name="discount"
                    autoComplete="off"
                    value={isProductData.discount}
                    className="form-control"
                    disabled
                  />
                </div>

                <div className="col-lg-4">
                  <label htmlFor="baseprice" className="form-label">
                    Base Price
                  </label>
                  <div className="input-container position-relative">
                    <input
                      type="text"
                      name="baseprice"
                      autoComplete="off"
                      ref={productBasepriceRef}
                      onClick={() => handleRadioChange("BASEPRICE")}
                      onChange={(e) => handleChange(e, changeParams)}
                      value={isProductData.baseprice}
                      onFocus={(e) => {
                        e.target.select();
                        setIsAnyInputFocused(true);
                      }}
                      className="form-control"
                      style={{ paddingLeft: "30px" }}
                      onKeyDown={(e) => {
                        if (
                          selectedProduct?._id &&
                          viewOption(
                            "stockSettings",
                            "isManufactureAndExpiryDates",
                          )
                        ) {
                          handleEnterKey(e, "baseprice", manufacturedateRefs);
                        } else if (selectedProduct?._id) {
                          handleEnterKey(e, "baseprice", productMdateRef);
                        } else {
                          handleEnterKey(e, "baseprice", productLandingCostRef);
                        }
                      }}
                    />
                    <input
                      type="radio"
                      name="priceLock"
                      checked={isProductData?.isLock === "BASEPRICE"}
                      onChange={() => handleRadioChange("BASEPRICE")}
                      className="position-absolute"
                      style={{
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        zIndex: 2,
                      }}
                    />
                  </div>
                  {error.baseprice && (
                    <div className="invalid-feedback">{error.baseprice}</div>
                  )}
                </div>

                <div className="col-lg-4">
                  <label htmlFor="taxamount" className="form-label">
                    Tax Amount
                  </label>
                  <input
                    readOnly=""
                    type="text"
                    name="taxamount"
                    autoComplete="off"
                    className="form-control"
                    value={isProductData.taxamount}
                    disabled
                  />
                </div>
                <div className="col-12 border-top"></div>
                {selectedProduct?._id && (
                  <>
                  {/* {uRLs.UNIT==="true" &&(
                    <>
                     <div className={unitData ? `col-lg-5` :'col-6'}>
                    <label htmlFor="quantity" className="form-label">
                      Stock <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="quantity"
                      autoComplete="off"
                      ref={productMdateRef}
                      value={isProductData.quantity}
                      onFocus={(e) => {
                        e.target.select();
                        setIsAnyInputFocused(true);
                      }}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        handleEnterKey(e, "quantity", null, true);
                      }}
                    />
                    {error.quantity && (
                      <div className="invalid-feedback">{error.quantity}</div>
                    )}
                  </div>
                  {unitData && (
                  <div className="col-3">
                    <div>
                    <label htmlFor="unit" className="form-label">
              Unit
              </label></div>
                  <div className="d-flex text-start align-items-center">
                 
                  <button
                          
                          className="btn btn-unit  border-end-0 rounded-end-0  w-100  dropdown-toggle-split"
                          id="printreceiptbtn"
                          data-bs-toggle="dropdown"
                        >
                          {selectedUnit}
                        </button>
                        <button
                          type="button" 
                          className="btn btn-unit  dropdown-toggle dropdown-toggle-split rounded-start-0 border-start-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        />
                        
                        <ul className="dropdown-menu dropdown-menu-end">
                         
                            <li>
                              <button
                                className={`dropdown-item ${
                                  selectedUnit === unitData?.primaryUnitName ? "active" : ""
                                }`}
                                onClick={() => {
                                  setSelectedUnit(unitData?.primaryUnitName);
                                }}
                              >
                                {unitData?.primaryUnitName}
                              </button>
                            </li>
                            {unitData?.secondaryUnitName && (
                            <li>
                              <button
                                className={`dropdown-item ${
                                  selectedUnit === unitData?.secondaryUnitName ? "active" : ""
                                }`}
                                onClick={() => {
                                  setSelectedUnit(unitData?.secondaryUnitName);
                                }}
                              >
                                {unitData?.secondaryUnitName}
                              </button>
                            </li>
                            )}
                        </ul>
                        </div>
                        </div>
                        )}
                  <div className={unitData ? 'col-4':'col-6'}>
                  <label htmlFor="unit" className="form-label">
              Unit
              </label>
                <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-unit fs-10 w-100 d-flex align-items-center justify-content-between"
                     
                    >
                      {defaultConversion?.unitName ? 
                                <span>{defaultConversion?.unitName}</span>
                                :
                                <span>Unit</span>} 
                              
                              </button></div>
                              {unitData &&(
                              <span>1 {unitData?.primaryUnitCode} = {unitData?.secondaryUnitCode ?`${unitData?.conversion} ${unitData?.secondaryUnitCode}`:'1 Unit'}</span>
                              )}
                    </div>
                    </>)} */}
                    {viewOption(
                      "stockSettings",
                      "isManufactureAndExpiryDates",
                    ) && (
                      <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className={uRLs.UNIT==="true"?"col-lg-4 mt-2":'col-lg-4'}>
                            <label
                              htmlFor="manufacturedate"
                              className="form-label"
                            >
                              Manufacture Date
                            </label>
                            <DatePicker
                              open={openMfgDate}
                              onOpen={() => setOpenMfgDate(true)}
                              onClose={() => setOpenMfgDate(false)}
                              disableOpenPicker // ❌ disables icon click
                              value={
                                isProductData?.manufacturedate
                                  ? dayjs(isProductData.manufacturedate)
                                  : null
                              }
                              format="DD MMM YYYY"
                              maxDate={dayjs(iso)}
                              onChange={(newValue) => {
                                if (!newValue) return;
                                handleMDateChange(newValue.toDate()); // ✅ single Date
                                setOpenMfgDate(false);
                              }}
                              slotProps={{
                                textField: {
                                  inputRef: manufacturedateRefs,
                                  fullWidth: true,
                                  size: "small",
                                  onClick: () => setOpenMfgDate(true),
                                  onKeyDown: (e) => {
                                    if (e.key === "Enter") {
                                      handleEnterKey(
                                        e,
                                        "manufacturedate",
                                        expiredateRefs,
                                      );
                                    } else {
                                      e.preventDefault();
                                    }
                                  },
                                  // onKeyDown: (e) =>
                                  //   handleEnterKey(
                                  //     e,
                                  //     "manufacturedate",
                                  //     expiredateRefs
                                  //   ),
                                  inputProps: { readOnly: true },
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                  },
                                },
                                openPickerButton: {
                                  sx: { display: "none" }, //  hide icon completely
                                },
                              }}
                            />
                          </div>

                          <div className={uRLs.UNIT==="true"?"col-lg-4 mt-2":'col-lg-4'}>
                            <label htmlFor="expiredate" className="form-label">
                              Expire Date
                            </label>
                            <DatePicker
                              open={openExpDate}
                              onOpen={() => setOpenExpDate(true)}
                              onClose={() => setOpenExpDate(false)}
                              disableOpenPicker
                              value={
                                isProductData?.expiredate
                                  ? dayjs(isProductData.expiredate)
                                  : null
                              }
                              format="DD MMM YYYY"
                              minDate={dayjs(expireMinDate)}
                              onChange={(newValue) => {
                                if (!newValue) return;
                                handleEDateChange(newValue.toDate());
                                setOpenExpDate(false);
                              }}
                              slotProps={{
                                textField: {
                                  inputRef: expiredateRefs,
                                  fullWidth: true,
                                  size: "small",
                                  onClick: () => setOpenExpDate(true),
                                  onKeyDown: (e) => {
                                    if (e.key === "Enter") {
                                      handleEnterKey(
                                        e,
                                        "expiredate",
                                        productMdateRef,
                                      );
                                    } else {
                                      e.preventDefault();
                                    }
                                  },
                                  // onKeyDown: (e) =>
                                  //   handleEnterKey(
                                  //     e,
                                  //     "expiredate",
                                  //     productMdateRef
                                  //   ),
                                  inputProps: { readOnly: true },
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                  },
                                },
                                openPickerButton: {
                                  sx: { display: "none" },
                                },
                              }}
                            />
                          </div>
                        </LocalizationProvider>
                      </>
                    )}
                  {/* {uRLs.UNIT!=="true" &&( */}
                    <div className="col-lg-4 mt-2">
                      <label htmlFor="quantity" className="form-label">
                        Stock <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="quantity"
                        autoComplete="off"
                        ref={productMdateRef}
                        value={isProductData.quantity}
                        onFocus={(e) => {
                          e.target.select();
                          setIsAnyInputFocused(true);
                        }}
                        onChange={(e) => handleChange(e, changeParams)}
                        onKeyDown={(e) => {
                          {
                            if (toggles["landingcost"]) {
                              handleEnterKey(
                                e,
                                "quantity",
                                productMultiCostRef,
                              );
                            } else {
                              handleEnterKey(e, "quantity", null, true);
                            }
                          }
                        }}
                        // onKeyDown={(e) => {
                        //   if (selectedProduct?._id) {
                        //     handleEnterKey(e, "quantity", productMultiCostRef);
                        //   } else {
                        //     handleEnterKey(e, "quantity", productNoteRef);
                        //   }
                        // }}
                      />
                      {(uRLs.UNIT==="true" && unitData) && (
                       <div className="d-flex text-start ">
                    <button
                          
                          className="btn btn-unit shadow-none  border-end-0 rounded-end-0 rounded-start-0  dropdown-toggle-split"
                          id="printreceiptbtn"
                          data-bs-toggle="dropdown"
                        >
                          {selectedUnit}
                        </button>
                    <button 
                          type="button" 
                          className="btn btn-unit shadow-none  dropdown-toggle dropdown-toggle-split rounded-start-0 border-start-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          // style={{ borderRight: "2px solid #fff" }}
                        />
                        <ul className="dropdown-menu dropdown-menu-end">
                         
                         <li>
                           <button
                             className={`dropdown-item ${
                               selectedUnit === unitData?.primaryUnitCode ? "active" : ""
                             }`}
                             onClick={() => {
                              //  setSelectedUnit(unitData?.primaryUnitCode);
                              productMdateRef.current.focus();
                               handleUnitConversion(unitData?.primaryUnitCode,'p')
                             }}
                           >
                             {unitData?.primaryUnitName} ({unitData?.primaryUnitCode})
                           </button>
                         </li>
                         {unitData?.secondaryUnitCode && ( 
                         <li>
                           <button
                             className={`dropdown-item ${
                               selectedUnit === unitData?.secondaryUnitCode ? "active" : ""
                             }`}
                             onClick={() => {
                              //  setSelectedUnit(unitData?.secondaryUnitCode);
                              productMdateRef.current.focus();
                               handleUnitConversion(unitData?.secondaryUnitCode,'s')
                             }}
                           >
                             {unitData?.secondaryUnitName} ({unitData?.secondaryUnitCode})
                           </button>
                         </li>
                         )}
                     </ul>
                        </div>)} 
                        </div>
                      {error.quantity && (
                        <div className="invalid-feedback">{error.quantity}</div>
                      )}
                    </div>
                    {/* )} */}
                  </>
                )}
                {!selectedProduct?._id && (
                  <>
                    <div className="col-lg-4">
                      <div className="d-flex align-items-center">
                        <label htmlFor="landingcost" className="form-label">
                          Landing Cost <small>(Per {unitData?.primaryUnitCode?unitData?.primaryUnitCode:"Unit"}) (Optional)</small>
                        </label>
                        <span className="tooltip-container">
                          <span className="tooltip-icon">?</span>
                          <span className="tooltip-text">
                            Total cost to bring the product to your inventory,
                            including purchase price and taxes.
                          </span>
                        </span>
                      </div>
                      <div className="input-container position-relative">
                        <input
                          type="text"
                          name="landingcost"
                          autoComplete="off"
                          ref={productLandingCostRef}
                          value={isProductData.landingcost}
                          className="form-control"
                          onFocus={(e) => {e.target.select();
                            setIsAnyInputFocused(true);}}
                          onChange={(e) => handleChange(e, changeParams)}
                          // onKeyDown={(e) =>
                          //   {if(viewOption("productSettings", "isProductTag")){
                          //   handleEnterKey(e, "landingcost", searchTagRef)}else{
                          //     handleEnterKey(e, "searchTag", brandRef);setShowSuggestions((prev) => !prev);setFilteredBrand(brandSuggest);
                          //   }
                          //   }
                          // }
                          onKeyDown={(e)=>{handleEnterKey(e, "landingcost", brandRef);
                          if (e.key === "Enter") {
                            setShowSuggestions((prev) => !prev);
                            setFilteredBrand(brandSuggest);
                          }}}
                        />
                      </div>
                    </div>
                    {!(uRLs.ADD_PRODUCT_IMAGE === "true" &&
              (viewOption("productSettings", "isPrimaryImage") ||
                viewOption("generalSettings", "isProductImage"))) &&
            <div className="col-8"></div>}
                    {/* {viewOption("productSettings", "isProductTag") && (
                    <div
                      className={"col-4 d-flex align-items-end"}
                    >
                      <div>
                      <label htmlFor="searchTag" className="form-label">
                        Product Tag 
                      </label>
                      
                      <input
                        type="text"
                        className="form-control"
                        name="searchTag"
                        autoComplete="off"
                        ref={searchTagRef}
                        value={isProductData?.searchTag}
                        onChange={handleChange}
                        onFocus={() => setIsAnyInputFocused(true)}
                        onKeyDown={(e) => {handleEnterKey(e, "searchTag", brandRef);setShowSuggestions((prev) => !prev);setFilteredBrand(brandSuggest);}}
                      />  
                      </div>
                      </div>
                      )} */}
                    {uRLs.ADD_PRODUCT_IMAGE === "true" &&
                        (viewOption("productSettings", "isPrimaryImage") ||
                          viewOption("generalSettings", "isProductImage")) && ( 
                          
                          <div className={`${viewOption("productSettings", "isProductTag") ? "col-8" :"col-8"} d-flex justify-content-end align-items-center`} style={{marginTop:"21px"}}>
                            <div className="pb-0">
                              <div className="row g-3">
                                <div className="">
                                  <div className="">
                                    <div
                                      className="profile-img-container"
                                      onClick={handleOpenImageModel}
                                    >
                                      <img
                                        id="logoimg"
                                        className="avatar"
                                        src={imagePreview}
                                        alt="profile-img mt-2"
                                        style={{
                                          width: "100%",
                                          maxWidth: "100%",
                                          objectFit: "cover",
                                          borderRadius: "8px",
                                          border: "2px solid #ddd",
                                        }}
                                      />

                                      {/* Hover Icon */}
                                      <div
                                        className="overlay-icon"
                                        onClick={() =>
                                          document
                                            .getElementById("logo_image_popup")
                                            .click()
                                        }
                                      >
                                        <PlusIcon/>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Hidden Input */}
                                  <input
                                    id="logo_image_popup"
                                    onClick={handleOpenImageModel}
                                    style={{ display: "none" }}
                                    disabled={isUploading}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                         {/* {viewOption("productSettings", "isProductTag") && (
                          <div className="col-12">
                          <label className="form-label">Product Tag</label>
                        
                          <div className="tag-input-container">
                          {tags?.map((tag, index) => (
                              <span className="tag-chip" key={index}>
                                {tag}
                                <span className="tag-close" onClick={() => removeTag(index)}>
                                  <i className="bx bx-x"></i>
                                </span>
                              </span>
                            ))}
                        
                            <input
                              type="text"
                              className="tag-input"
                              value={tagInput}
                              ref={searchTagRef}
                              onChange={(e) => setTagInput(e.target.value)}
                              onKeyDown={handleTagKeyDown}
                              placeholder="Type and press Enter"
                            />
                          </div>
                        </div>
                        )} */}
                        <div className="col-5">
                      <label className="form-label">Brand</label>

                      <div className="position-relative" ref={primaryRef}>
                        {/* Trigger */}
                        {showSuggestions && (
                          <div className="dropdown-menu show w-100 p-2 mt-1 shadow-sm" 
                          style={{
                            bottom: "100%",
                            top: "auto",
                            marginBottom: "5px",
                            borderTopLeftRadius: "0px",
                            borderTopRightRadius: "0px",
                          }}>
                            {/* Search */}
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search or add new..."
                              ref={brandRef}
                              value={searchTerm}
                              onChange={(e) => {
                                const value = e.target.value;
                                setSearchTerm(value);

                                if (value.trim() === "") {
                                  setFilteredBrand(brandSuggest);
                                } else {
                                  const filtered = brandSuggest.filter((item) =>
                                    item.title.toLowerCase().includes(value.toLowerCase())
                                  );
                                  setFilteredBrand(filtered);
                                }

                                setBrandIndex(-1);
                              }}
                              onFocus={() => setIsAnyInputFocused(true)}
                              onKeyDown={handleBrandKeyDown}
                              autoFocus
                            />

                            <ul className="suggestions-list-top shadow-bottom-none"
                            style={{ maxHeight: "150px", 
                            borderBottomLeftRadius:'0px',
                            borderBottomRightRadius:'0px',
                            borderBottom:"0",
                            boxShadow: "0 -2px 8px rgba(0,0,0,0.1)", }}>
                              
                              {/*  Add new */}
                              {filteredBrand?.length === 0 && searchTerm?.trim() !== "" && (
                                    <li
                                      className={`suggestion-item text-primary ${
                                        brandIndex === 0 ? "highlighted rounded" : ""
                                      }`}
                                      onMouseDown={() => handleBrandAdd(searchTerm)}
                                    >
                                      <span className="p-2 rounded-3 badge bg-label-primary d-flex align-items-center">
                                        <AddIcon iClass={"me-1"}/> "{searchTerm}"
                                      </span>
                                    </li>
                                  )}

                              {/* List */}
                              {filteredBrand?.map((item, index) => (
                                <li
                                  key={item?._id}
                                  className={`suggestion-item mx-2 ${
                                    index === brandIndex ? "highlighted rounded" : ""
                                  }`}
                                  ref={(el) => (itemRefs.current[index] = el)}
                                  onMouseDown={() => handleSelectBrand(item)}
                                >
                                  {item?.title}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setShowSuggestions((prev) => !prev);
                            setSearchTerm("");
                            setFilteredBrand(brandSuggest); //  show all
                            setBrandIndex(-1);
                          }}
                        >
                          <span className={brandData?.title ? "" : "text-muted"}>
                            {brandData?.title || "Select brand"}
                          </span>
                          <span className="d-flex align-items-center">
                            {brandData?.title &&(
                          // <i className="bx bx-x me-2" onClick={()=>setBrandData("")}></i>
                          <CancelRoundedIcon sx={{fontSize:15}} onClick={()=>setBrandData("")}/>
                          )}
                          <i className={`bx bx-chevron-${showSuggestions ? "up" : "down"}`} />
                          </span>
                        </div>

                        {/* Dropdown */}
                       
                      </div>
                    </div>
                    <div className="col-7">
                      <label htmlFor="title" className="form-label">
                        Note
                      </label>
                      <div className="position-relative" ref={containerRef}>
                        <input
                          type="text"
                          className="form-control"
                          name="note"
                          autoComplete="off"
                          ref={productNoteRef}
                          value={isProductData.note}
                          onChange={(e) => handleChange(e, changeParams)}
                          onKeyDown={(e) => {
                            if(viewOption("productSettings", "isShortName")){
                              handleEnterKey(e, "note", productShortNameRef)
                            } else if (viewOption("productSettings", "isProductTag")) {
                              handleEnterKey(e, "note", searchTagRef);
                            }
                            else if (
                              toggles["stock"] &&
                              viewOption(
                                "stockSettings",
                                "isManufactureAndExpiryDates",
                              )
                            ) {
                              handleEnterKey(e, "note", manufacturedateRefs);
                            } else if (toggles["stock"]) {
                              handleEnterKey(e, "note", productMdateRef);
                            } else {
                              handleEnterKey(e, "note", null, true);
                            }
                          }}
                          onFocus={() => {
                            setFilteredNoteSuggestions(noteSuggest);
                            setShowNotePopup(true);
                            noteOpenStatus(true);
                            setHighlightedIndex(-1);
                            setIsAnyInputFocused(true);
                          }}
                          onBlur={() => {
                            setTimeout(() => {
                              setShowNotePopup(false);
                              noteOpenStatus(false);
                            }, 150);
                          }}
                          style={{ paddingRight: isProductData.note ? "30px" : undefined }}
                        />
                    {isProductData.note && (
                          <button
                            type="button"
                            onMouseDown={(e) => {
                              // prevent input blur before we clear
                              e.preventDefault();
                            }}
                            onClick={() => {
                              setProductData((prev) => ({
                                ...prev,
                                note: "",
                              }));
                              productNoteRef.current?.focus();
                            }}
                            className="noteclose"
                            aria-label="Clear note"
                          >
                            <CancelRoundedIcon
                              sx={{ fontSize: 15 }}
                              />
                          </button>
                        )}
                        {showNotePopup &&
                          Object.values(filteredNoteSuggestions).flat().length >
                            0 && (
                            <ul className="suggestions-list-top">
                              {[
                                // Put "General" first if it exists
                                ...(filteredNoteSuggestions["General"]
                                  ? [
                                      [
                                        "General",
                                        filteredNoteSuggestions["General"],
                                      ],
                                    ]
                                  : []),

                                // Then add all other categories
                                ...Object.entries(
                                  filteredNoteSuggestions,
                                ).filter(
                                  ([category]) => category !== "General",
                                ),
                              ].map(([category, items], catIndex) => (
                                <li key={catIndex}>
                                  <div className="suggestion-item highlighted-title">
                                    {category}
                                  </div>
                                  <ul className="suggestions-list-inside">
                                    {items.map((item, idx) => {
                                      const flatIndex =
                                        flatSuggestions.indexOf(item);
                                      return (
                                        <li
                                          key={`${catIndex}-${idx}`}
                                          ref={(el) =>
                                            (suggestionNoteRef.current[
                                              flatIndex
                                            ] = el)
                                          }
                                          className={`suggestion-item ${
                                            highlightedIndex === flatIndex
                                              ? "highlighted"
                                              : ""
                                          }`}
                                          onMouseDown={() => {
                                            setProductData((prev) => ({
                                              ...prev,
                                              note: item,
                                            }));
                                            setShowNotePopup(false);
                                            noteOpenStatus(false);
                                            setHighlightedIndex(-1);
                                          }}
                                        >
                                          {item}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          )}
                      </div>
                    </div>
                    {viewOption("productSettings", "isShortName") && (
                    <div className="col-12">
                      <label htmlFor="shortName" className="form-label">
                        Short Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="shortName"
                        autoComplete="off"
                        ref={productShortNameRef}
                        value={isProductData?.shortName}
                        onChange={(e) => handleChange(e, changeParams)}
                        onFocus={(e) => {
                          e.target.select();
                          setIsAnyInputFocused(true);
                        }}
                        onKeyDown={(e) => {
                          if(viewOption("productSettings", "isProductTag")){
                          handleEnterKey(e, "shortName", searchTagRef)
                          }else if(
                            toggles["stock"] &&
                            viewOption(
                              "stockSettings",
                              "isManufactureAndExpiryDates",
                            )
                          ) {
                            handleEnterKey(e, "shortName", manufacturedateRefs);
                          } else if
                          (toggles["stock"]) {
                            handleEnterKey(e, "shortName", productMdateRef);
                          } else {
                            handleEnterKey(e, "shortName", null, true);
                          }
                          }}
                      />
                    </div>)}
                    {viewOption("productSettings", "isProductTag") && (
                          <div className="col-12">
                          <label className="form-label">Search Tag</label>
                        
                          <div className="tag-input-container">
                          {tags?.map((tag, index) => (
                              <span className="tag-chip" key={index}>
                                {tag}
                                <span className="tag-close" onClick={() => removeTag(index)}>
                                  < CancelRoundedIcon sx={{fontSize:15}}/>
                                </span>
                              </span>
                            ))}
                        
                            <input
                              type="text"
                              className="tag-input"
                              value={tagInput}
                              ref={searchTagRef}
                              onChange={(e) => setTagInput(e.target.value)}
                              onKeyDown={handleTagKeyDown}
                              placeholder="Type and press Enter"
                            />
                          </div>
                        </div>
                        )}
                  </>
                )}
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {selectedProduct && !selectedProduct?._id && (
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-12">
                <div className="list-group-item py-2 ">
                  <div className="d-flex align-items-center">
                    <span className="fw-600">
                      Stock Details <span className="text-danger">*</span>
                    </span>
                    <div className="ms-auto custom-toggle-wrapper">
                      <label className="custom-toggle cursor-pointer">
                        <input
                          type="checkbox"
                          id="stockToggle"
                          checked={toggles["stock"]}
                          onChange={() => handleToggleChange("stock")}
                          disabled={loading["stock"]}
                        />
                        <span className="slider">
                          {loading["stock"] ? (
                            <span
                              className={`spinner-inside ${
                                toggles["stock"] ? "spinner-right" : ""
                              }`}
                            />
                          ) : (
                            <>
                              {toggles["stock"] ? (
                                <span className="label-on ms-0-1"></span>
                              ) : (
                                <span className="label-off ms-3"></span>
                              )}
                            </>
                          )}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                {/*  Section visible only when toggle is ON */}
                <div
                  className={`toggle-section ${
                    toggles["stock"] ? "show-section" : "hide-section"
                  }`}
                >
                  <div className="row">
                    {/* <span className="fw-semibold mb-2 fs-6">Stock Details</span> */}
                    {/* {uRLs.UNIT==="true" &&(
                    <>
                     <div className={unitData ? `col-lg-5` :'col-6'}>
                    <label htmlFor="quantity" className="form-label">
                      Stock <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="quantity"
                      autoComplete="off"
                      ref={productMdateRef}
                      value={isProductData.quantity}
                      onFocus={(e) => {
                        e.target.select();
                        setIsAnyInputFocused(true);
                      }}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        handleEnterKey(e, "quantity", null, true);
                      }}
                    />
                    {error.quantity && (
                      <div className="invalid-feedback">{error.quantity}</div>
                    )}
                  </div>
                  {unitData && (
                  <div className="col-3">
                    <div>
                    <label htmlFor="unit" className="form-label">
              Choose unit
              </label></div>
                  <div className="btn-group text-start align-items-center">
                  <button
                          type="button" 
                          className="btn btn-unit  dropdown-toggle dropdown-toggle-split"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{ borderRight: "2px solid #fff" }}
                        />
                  <button
                          
                          className="btn btn-unit rounded-end w-100"
                          id="printreceiptbtn"
                        >
                          {selectedUnit}
                        </button>
                        
                        <ul className="dropdown-menu dropdown-menu-end">
                         
                            <li>
                              <button
                                className={`dropdown-item ${
                                  selectedUnit === unitData?.primaryUnitName ? "active" : ""
                                }`}
                                onClick={() => {
                                  setSelectedUnit(unitData?.primaryUnitName);
                                }}
                              >
                                {unitData?.primaryUnitName}
                              </button>
                            </li>
                            {unitData?.secondaryUnitName && (
                            <li>
                              <button
                                className={`dropdown-item ${
                                  selectedUnit === unitData?.secondaryUnitName ? "active" : ""
                                }`}
                                onClick={() => {
                                  setSelectedUnit(unitData?.secondaryUnitName);
                                }}
                              >
                                {unitData?.secondaryUnitName}
                              </button>
                            </li>
                            )}
                        </ul>
                        </div>
                        </div>
                        )}
                  <div className={unitData ? 'col-4':'col-6'}>
                  <label htmlFor="unit" className="form-label">
              Unit
              </label>
                <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-unit fs-10 w-100 d-flex align-items-center justify-content-between"
                      onClick={()=>{setAddUnitopen(true);setGlobelPopupOpen(true);}}
                      
                    >
                      {unitData?.primaryUnitName ? 
                       <span>{unitData?.primaryUnitName}</span>
                      :
                      <span>Unit</span>}<i className="ng ng-ng-edit-icon me-1 "></i> 
                    </button></div>
                    {unitData &&(
                    <span>1 {unitData?.primaryUnitCode} = {unitData?.secondaryUnitCode ?`${unitData?.conversion} ${unitData?.secondaryUnitCode}`:'1 Unit'}</span>
                    )}
                    </div>
                    </>)} */}
                    {viewOption(
                      "stockSettings",
                      "isManufactureAndExpiryDates",
                    ) && (
                      <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className={uRLs.UNIT==="true"?"col-lg-4 mt-2":'col-lg-4'}>
                            <label
                              htmlFor="manufacturedate"
                              className="form-label"
                            >
                              Manufacture Date
                            </label>
                            <DatePicker
                              open={openMfgDate}
                              onOpen={() => setOpenMfgDate(true)}
                              onClose={() => setOpenMfgDate(false)}
                              disableOpenPicker //  disables icon click
                              value={
                                isProductData?.manufacturedate
                                  ? dayjs(isProductData.manufacturedate)
                                  : null
                              }
                              format="DD MMM YYYY"
                              maxDate={dayjs(iso)}
                              onChange={(newValue) => {
                                if (!newValue) return;
                                handleMDateChange(newValue.toDate()); //  single Date
                                setOpenMfgDate(false);
                              }}
                              slotProps={{
                                textField: {
                                  inputRef: manufacturedateRefs,
                                  fullWidth: true,
                                  size: "small",
                                  onClick: () => setOpenMfgDate(true),
                                  onKeyDown: (e) => {
                                    if (e.key === "Enter") {
                                      handleEnterKey(
                                        e,
                                        "manufacturedate",
                                        expiredateRefs,
                                      );
                                    } else {
                                      e.preventDefault();
                                    }
                                  },
                                  inputProps: { readOnly: true },
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                  },
                                },
                                openPickerButton: {
                                  sx: { display: "none" },
                                },
                              }}
                            />
                          </div>

                          <div className={uRLs.UNIT==="true"?"col-lg-4 mt-2":'col-lg-4'}>
                            <label htmlFor="expiredate" className="form-label">
                              Expire Date
                            </label>
                            <DatePicker
                              open={openExpDate}
                              onOpen={() => setOpenExpDate(true)}
                              onClose={() => setOpenExpDate(false)}
                              disableOpenPicker
                              value={
                                isProductData?.expiredate
                                  ? dayjs(isProductData.expiredate)
                                  : null
                              }
                              format="DD MMM YYYY"
                              minDate={dayjs(expireMinDate)}
                              onChange={(newValue) => {
                                if (!newValue) return;
                                handleEDateChange(newValue.toDate());
                                setOpenExpDate(false);
                              }}
                              slotProps={{
                                inputRef: expiredateRefs,
                                textField: {
                                  fullWidth: true,
                                  size: "small",
                                  onClick: () => setOpenExpDate(true),
                                  onKeyDown: (e) => {
                                    if (e.key === "Enter") {
                                      handleEnterKey(
                                        e,
                                        "expiredate",
                                        productMdateRef,
                                      );
                                    } else {
                                      e.preventDefault();
                                    }
                                  },
                                  // onKeyDown: (e) =>
                                  //   handleEnterKey(
                                  //     e,
                                  //     "expiredate",
                                  //     productMdateRef
                                  //   ),
                                  inputProps: { readOnly: true },
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      cursor: "pointer",
                                    },
                                  },
                                },
                                openPickerButton: {
                                  sx: { display: "none" },
                                },
                              }}
                            />
                          </div>
                        </LocalizationProvider>
                      </>
                    )}
                  {/* {uRLs.UNIT!=="true" && ( */}
                    <div className="col-lg-4 mt-2">
                      <label htmlFor="quantity" className="form-label">
                        Stock <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="quantity"
                        autoComplete="off"
                        ref={productMdateRef}
                        value={isProductData.quantity}
                        onFocus={(e) => {
                          e.target.select();
                          setIsAnyInputFocused(true);
                        }}
                        onChange={(e) => handleChange(e, changeParams)}
                        onKeyDown={(e) => {
                          handleEnterKey(e, "quantity", null, true);
                        }}
                      />
                      {(uRLs.UNIT==="true" && unitData) && (
                      <div className="d-flex text-start">
                    <button
                          
                          className="btn btn-unit shadow-none  border-end rounded-end rounded-start-0  dropdown-toggle-split"
                          // id="printreceiptbtn"
                          // data-bs-toggle="dropdown"
                        >
                          {selectedUnit}
                        </button>
                    {/* <button
                          type="button" 
                          className="btn btn-unit shadow-none  dropdown-toggle dropdown-toggle-split rounded-start-0 border-start-0"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          
                        /> */}
                        {/* <ul className="dropdown-menu dropdown-menu-end">
                         
                         <li>
                           <button
                             className={`dropdown-item ${
                               selectedUnit === unitData?.primaryUnitCode ? "active" : ""
                             }`}
                             onClick={() => {
                               setSelectedUnit(unitData?.primaryUnitCode);
                             }}
                           >
                             {unitData?.primaryUnitName} ({unitData?.primaryUnitCode})
                           </button>
                         </li>
                         {unitData?.secondaryUnitName && (
                         <li>
                           <button
                             className={`dropdown-item ${
                               selectedUnit === unitData?.secondaryUnitCode ? "active" : ""
                             }`}
                             onClick={() => {
                              handleUnitConversion(unitData?.secondaryUnitCode,'s');
                             }}
                           >
                             {unitData?.secondaryUnitName} ({unitData?.secondaryUnitCode})
                           </button>
                         </li>
                         )}
                     </ul> */}
                        </div>
                      )}
                        </div>
                      {error.quantity && (
                        <div className="invalid-feedback">{error.quantity}</div>
                      )}
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {selectedProduct?._id && (
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-12">
                <div className="list-group-item py-2">
                  <div className="d-flex align-items-center">
                    <span className="fw-600">Landing Cost</span>
                    <div className="ms-auto custom-toggle-wrapper">
                      <label className="custom-toggle cursor-pointer">
                        <input
                          type="checkbox"
                          id="stockToggle"
                          checked={toggles["landingcost"]}
                          onChange={() => handleToggleChange("landingcost")}
                          disabled={loading["stock"]}
                        />
                        <span className="slider">
                          {loading["landingcost"] ? (
                            <span
                              className={`spinner-inside ${
                                toggles["landingcost"] ? "spinner-right" : ""
                              }`}
                            />
                          ) : (
                            <>
                              {toggles["landingcost"] ? (
                                <span className="label-on ms-0-1"></span>
                              ) : (
                                <span className="label-off ms-3"></span>
                              )}
                            </>
                          )}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  className={`toggle-section ${
                    toggles["landingcost"] ? "show-section" : "hide-section"
                  }`}
                >
                  <div className="row">
                    {/* <div className="col-12 mb-2 fs-6">
                    <span className="fw-semibold">Landing Cost</span>
                  </div> */}

                    {/* Labels Row */}
                    {viewOption("stockSettings", "isLandingCostMultiplier") && (
                      <>
                        <div className="col-3 d-flex align-items-center justify-content-start">
                          <label
                            htmlFor="lcmultiplayer"
                            className="form-label text-expense"
                          >
                            Multiplier
                            <span className="tooltip-container ms-1">
                              <span className="tooltip-icon">?</span>
                              <span className="tooltip-text">
                                When adding stock, you can enter a multiplier in
                                the extra box to recalculate the landing cost.
                                For example, 1.5 × ₹50 = ₹75. If this feature is
                                turned off, the system will use the manual value
                                you enter.
                              </span>
                            </span>
                          </label>
                        </div>
                        <div className="col-1 text-center"></div>
                        <div className="col-3 d-flex align-items-center justify-content-center">
                          <label
                            htmlFor="finallandingcost"
                            className="form-label text-brown"
                          >
                            Landing&nbsp;Cost&nbsp;
                            <span className="tooltip-container">
                              <span className="tooltip-icon">?</span>
                              <span className="tooltip-text">
                                Total cost to bring the product to your
                                inventory, including purchase price and taxes.
                              </span>
                            </span>
                          </label>
                        </div>
                        <div className="col-1 text-center"></div>
                      </>
                    )}
                    <div className="col-4">
                      <label
                        htmlFor="landingcost"
                        className="form-label bg-dark-text"
                      >
                        Final Landing Cost <small>(Per {unitData?.primaryUnitCode?unitData?.primaryUnitCode:"Unit"}) (Optional)</small>
                        <span className="tooltip-container ms-1">
                          <span className="tooltip-icon">?</span>
                          <span className="tooltip-text">
                            Total cost to bring the product to your inventory,
                            including purchase price and taxes.
                          </span>
                        </span>
                      </label>
                    </div>

                    {/* Inputs Row */}
                    {viewOption("stockSettings", "isLandingCostMultiplier") && (
                      <>
                        <div className="col-3">
                          <input
                            type="text"
                            name="lcmultiplayer"
                            autoComplete="off"
                            ref={productMultiCostRef}
                            value={isProductData?.lcmultiplayer}
                            className="form-control"
                            onFocus={(e) => {
                              e.target.select();
                              setIsAnyInputFocused(true);
                            }}
                            onChange={(e) => handleChange(e, changeParams)}
                            onKeyDown={(e) =>
                              handleEnterKey(
                                e,
                                "landingcost",
                                productLandingCostRef,
                              )
                            }
                          />
                        </div>

                        <div className="col-1 d-flex align-items-center justify-content-center fs-4">
                          <i className="bx text-muted">⨯</i>
                        </div>

                        <div className="col-3 d-flex align-items-center justify-content-center">
                          <span className="badge bg-label-wood fs-6">
                            ₹{isProductData?.finalLandingCost}
                          </span>
                        </div>

                        <div className="col-1 d-flex align-items-center justify-content-center fs-4">
                          <LineDoubleIcon iClass={"text-muted"}/>
                        </div>
                      </>
                    )}
                    <div className="col-4">
                      <input
                        type="text"
                        name="landingcost"
                        autoComplete="off"
                        ref={productLandingCostRef}
                        value={isProductData?.landingcost}
                        className="form-control"
                        onFocus={(e) => {
                          e.target.select();
                          setIsAnyInputFocused(true);
                        }}
                        onChange={(e) => handleChange(e, changeParams)}
                        onKeyDown={(e) =>
                          handleEnterKey(e, "landingcost", null, true)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="accordion accordion-flush">
        <>
          {/* {selectedProduct && !selectedProduct?._id && (
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                  fdprocessedid="5b1j1a"
                >
                  Stock Details <span className="text-danger">*</span>
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse show"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                
                  <div className="row">
                    {viewOption(
                      "stockSettings",
                      "isManufactureAndExpiryDates"
                    ) && (
                      <>
                        <div className="col-lg-4">
                          <label
                            htmlFor="manufacturedate"
                            className="form-label"
                          >
                            Manufacture Date
                          </label>
                          <Flatpickr
                            value={manufacturedate}
                            ref={manufacturedateRefs}
                            onChange={handleMDateChange}
                            options={{
                              maxDate: indiaTime,
                              // dateFormat: "d M Y",
                            }}
                            className="form-control"
                            onKeyDown={(e) =>
                              handleEnterKey(
                                e,
                                "manufacturedate",
                                expiredateRefs
                              )
                            }
                          />
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="expiredate" className="form-label">
                            Expire Date
                          </label>
                          <Flatpickr
                            value={expiredate}
                            ref={expiredateRefs}
                            onChange={handleEDateChange}
                            className="form-control"
                            options={{
                              minDate: expireMinDate,
                              // dateFormat: "d M Y",
                            }}
                            onKeyDown={(e) =>
                              handleEnterKey(e, "expiredate", productMdateRef)
                            }
                          />
                        </div>
                      </>
                    )}

                    <div className="col-lg-4">
                      <label htmlFor="quantity" className="form-label">
                        Stock <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="quantity"
                        autoComplete="off"
                        ref={productMdateRef}
                        value={isProductData.quantity}
                        onFocus={(e) => e.target.select()}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          handleEnterKey(e, "quantity", null, true);
                        }}
                      />
                      {error.quantity && (
                        <div className="invalid-feedback">{error.quantity}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )} */}
          {selectedProduct ? (
            <>
              {/* <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                    fdprocessedid="ysxib"
                  >
                    Landing Cost (Optional)
                  </button>
                </h2>
                <div
                  id="flush-collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingTwo"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <div className="row">
                      <div className="col-12 mb-2 fs-6">
                        <span className="fw-semibold">Landing Cost</span>
                      </div>

                      {viewOption(
                        "stockSettings",
                        "isLandingCostMultiplier"
                      ) && (
                        <>
                          <div className="col-3 d-flex align-items-center justify-content-center">
                            <label
                              htmlFor="lcmultiplayer"
                              className="form-label text-expense"
                            >
                              Multiplier
                              <span className="tooltip-container ms-1">
                                <span className="tooltip-icon">?</span>
                                <span className="tooltip-text">
                                  When adding stock, you can enter a multiplier
                                  in the extra box to recalculate the landing
                                  cost. For example, 1.5 × ₹50 = ₹75. If this
                                  feature is turned off, the system will use the
                                  manual value you enter.
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="col-1 text-center"></div>
                          <div className="col-3 d-flex align-items-center justify-content-center">
                            <label
                              htmlFor="finallandingcost"
                              className="form-label text-brown"
                            >
                              Landing Cost
                              <span className="tooltip-container ms-1">
                                <span className="tooltip-icon">?</span>
                                <span className="tooltip-text">
                                  Total cost to bring the product to your
                                  inventory, including purchase price and taxes.
                                </span>
                              </span>
                            </label>
                          </div>
                          <div className="col-1 text-center"></div>
                        </>
                      )}
                      <div className="col-4">
                        <label
                          htmlFor="landingcost"
                          className="form-label bg-dark-text"
                        >
                          Final Landing Cost{" "}
                          <small>(Per Unit) (Optional)</small>
                          <span className="tooltip-container ms-1">
                            <span className="tooltip-icon">?</span>
                            <span className="tooltip-text">
                              Total cost to bring the product to your inventory,
                              including purchase price and taxes.
                            </span>
                          </span>
                        </label>
                      </div>
                      {viewOption(
                        "stockSettings",
                        "isLandingCostMultiplier"
                      ) && (
                        <>
                          <div className="col-3">
                            <input
                              type="text"
                              name="lcmultiplayer"
                              autoComplete="off"
                              ref={productMultiCostRef}
                              value={isProductData?.lcmultiplayer}
                              className="form-control"
                              onFocus={(e) => e.target.select()}
                              onChange={handleChange}
                              onKeyDown={(e) =>
                                handleEnterKey(
                                  e,
                                  "landingcost",
                                  productLandingCostRef
                                )
                              }
                            />
                          </div>

                          <div className="col-1 d-flex align-items-center justify-content-center fs-4">
                            <i className="bx text-muted">⨯</i>
                          </div>

                          <div className="col-3 d-flex align-items-center justify-content-center">
                            <span className="badge bg-label-wood fs-6">
                              ₹{isProductData?.finalLandingCost}
                            </span>
                          </div>

                          <div className="col-1 d-flex align-items-center justify-content-center fs-4">
                            <i className="lni lni-line-double text-muted"></i>
                          </div>
                        </>
                      )}
                      <div className="col-4">
                        <input
                          type="text"
                          name="landingcost"
                          autoComplete="off"
                          ref={productLandingCostRef}
                          value={isProductData?.landingcost}
                          className="form-control"
                          onFocus={(e) => e.target.select()}
                          onChange={handleChange}
                          onKeyDown={(e) =>
                            handleEnterKey(e, "landingcost", null, true)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="card ">
                <div className="card-body">
                  <button
                    type="button"
                    className="btn btn-outline-secondary text-left"
                    onClick={handleClose}
                  >
                    <XIcon/> Cancel
                  </button>
                  {isBtnLoading ? (
                    <button className="btn btn-teal pb-0 text-right" disabled>
                      <CircularProgress size={22} className="text-white" />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-teal text-right"
                      onClick={onAdd}
                      ref={addStockBtnRef}
                    >
                      {selectedProduct?._id || isProductData?.quantity > 0 ? (
                        <>
                          <StockAddIcon/> Add Stock
                        </>
                      ) : (
                        <>
                          <AddIcon/> Add Product
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </>
      </div>
      {/* {showMrpPopup && (
        <input
          type="text"
          ref={popupMrpInputRef}
          value={popupMrpValue}
          onChange={(e) => {
            const val = e.target.value;
            setPopupMrpValue(val);
            setProductData((prev) => ({ ...prev, mrp: val }));
            handleCalculate({ ...isProductData, mrp: val });
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setShowMrpPopup(false);
              setTimeout(() => {
                productSalepriceRef?.current?.focus();
              }, 0);
            }
          }}
          onBlur={() => setShowMrpPopup(false)}
          autoFocus
          onFocus={(e) => e.target.select()}
          style={popupMrpStyle}
          className="form-control position-absolute"
        />
      )} */}
      {isImageModalOpen && (
        <AddImage
          onClose={handleImageClose}
          data={imageFile}
          onAdd={handleAddImage}
        />
      )}
      {AddUnitopen && (
      <CustomUnit  
      onclose={()=>handleCloseUnit()} 
      unitSuggest={unitSuggest}
      setUnitSuggest={setUnitSuggest}
      onAdd={handleUnit}
      selectedData={unitData}/>)}
      {isEditModalOpen && (
          <EditProduct
            isActive={isActive}
            editData={editData}
            onClose={onClose}
            onEdit={onEdit}
            isBtnLoading={isBtnLoad}
            noteSuggests={noteSuggest}
            brandSuggest={brandSuggest}
            setBrandSuggest={setBrandSuggest}
          />
        )}
    </>
  );
};

export default AddStock;
